const CollectionFilterClass = function () {

    let nodelist = document.querySelectorAll('.product-card');
    if(nodelist.length === 0){
        this.classKey = '.product-card-2024'
    }else{
        this.classKey = '.product-card'
    }

    document.addEventListener("DOMContentLoaded", function () {
        console.log('CollectionFilterClass');
        collectionFilter.initializeFilters();
    })


    this.toggleCollectionFilter = function(){
        document.body.classList.toggle('ProductGrid--controls__visible');

    }

    this.closeCollectionFilter = function(){
        document.body.classList.remove('ProductGrid--controls__visible');
    }



    this.unsetGrid = function() {
        let nodelist = document.querySelectorAll(this.classKey);
        for (let i=0; i< nodelist.length; i++) {
            nodelist[i].parentNode.classList.remove('d-none')
        }
    }

    this.unsetAll = function() {
        collectionFilter.unsetSelection();
        collectionFilter.unsetGrid();
        document.querySelector('.ProductGrid--controls-interface__selection').innerHTML = "";
        document.querySelector('.ProductGrid--controls-interface__reset')?.classList.remove('d-flex')

    }

    this.unsetSelf = function(e,dataKey) {
        e.currentTarget.remove();
        let searches = document.querySelectorAll('.ProductGrid--controls  li > div.filter-active');
        for (let i=0; i< searches.length; i++) {
            if(dataKey == searches[i].getAttribute('data-key')){
                searches[i].classList.remove('filter-active');
            }
        }
        collectionFilter.filterGrid();
    }


    this.displayBubbles = function(searches) {
        console.log(searches);
        let html = "";
        for (let i=0; i< searches.length; i++) {
            let dataKey = searches[i].getAttribute('data-key');
            html+= "<div onclick='collectionFilter.unsetSelf(event,\""+dataKey+"\")' class='ProductGrid--controls-interface__selector mr-md mb-sm mt-sm' ><span>"+searches[i].innerHTML+"</span><div class='ProductGrid--controls-interface__close-x'>&times</div></div>";
        }
        document.querySelector('.ProductGrid--controls-interface__selection').innerHTML = html;
        if("" != html){
            document.querySelector('.ProductGrid--controls-interface__reset')?.classList.add('d-flex')
        }else{
            document.querySelector('.ProductGrid--controls-interface__reset')?.classList.remove('d-flex')
        }

    }

    this.filterGrid = function() {
        console.log('filterGrid');

        let searches = document.querySelectorAll('.ProductGrid--controls  li > div.filter-active');
        collectionFilter.displayBubbles(searches);
        let nodelist = document.querySelectorAll(this.classKey);


        if(!searches || searches.length === 0){
            for (let i=0; i< nodelist.length; i++) {
                let el = nodelist[i];
                el.parentNode.classList.remove('d-none');
            }
            collectionFilter.closeCollectionFilter();
            return
        }
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            el.parentNode.classList.add('d-none');
        }
        for (let k=0; k< searches.length; k++) {
            let search = searches[k].getAttribute('data-key');
            console.log("Searches: "+ search);
            for (let i=0; i< nodelist.length; i++) {
                let el = nodelist[i];

                let collections = el.getAttribute('data-product-collections').toLowerCase().split(",");
                let family = el.getAttribute('data-product-fragrance-family').toLowerCase().split(",");
                let note = el.getAttribute('data-product-fragrance-note').toLowerCase().split(",");
                let size = el.getAttribute('data-product-sizes-available').toLowerCase().split(",");

                //console.log(collections)
                //console.log(family)
                //console.log(note)
                //console.log(size)

                if(collections.includes(search.toLowerCase())){
                    el.parentNode.classList.remove('d-none');
                }

                if(family.includes(search.toLowerCase())){
                    el.parentNode.classList.remove('d-none');
                }

                if(note.includes(search.toLowerCase())){
                    el.parentNode.classList.remove('d-none');
                }

                size.forEach((key) => {
                    if(key.includes(search.toLowerCase())){
                        el.parentNode.classList.remove('d-none')
                    }
                })

            }
        }



    }

    this.unsetSelection = function() {
        console.log('unsetSelection');
        let nodelist = document.querySelectorAll('.ProductGrid--controls div');
        for (let i=0; i< nodelist.length; i++) {
            nodelist[i].classList.remove('filter-active');
        }
    }


    this.setSizesAvailable = function() {
        dqsa(this.classKey).forEach((card) => {
            let options = []
            card.querySelectorAll(".quick-add-interface-2024__option-label").forEach((el) => {
                let dummy = document.createElement( 'div' );
                dummy.innerHTML = el.innerHTML
                dummy.querySelectorAll('span').forEach((el2) => {el2.remove()})
                options.push(dummy.innerHTML.trim())
                // el.getAttribute('data-product-fragrance-note')
            })
            //console.log(options)
            card.setAttribute('data-product-sizes-available',options.join().toLowerCase())
        })
    }

    this.initializeFilters = function() {
        console.log('initializeFilters');

        this.setSizesAvailable()

        let nodelist = document.querySelectorAll('.ProductGrid--controls  li > div');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize');
                //let result = collectionFilter.findInProducts('data-product-collections',el.getAttribute('data-key'));
                //el.innerHTML+= " ("+result+")";
                el.onclick = function(e){
                    if(el.classList.contains('filter-active')){
                        el.classList.remove('filter-active')
                    }else{
                        //collectionFilter.unsetSelection();
                        el.classList.add('filter-active')
                    }
                    collectionFilter.filterGrid();
                };
            }
        }

        /*
        nodelist = document.querySelectorAll('.ProductGrid--filter-fragrance-family li > div');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize');
                //let result = collectionFilter.findInProducts('data-product-fragrance-family',el.getAttribute('data-key'));
                //el.innerHTML+= " ("+result+")";
                el.onclick = function(e){

                    if(el.classList.contains('filter-active')){
                        el.classList.remove('filter-active');
                    }else{
                        collectionFilter.unsetSelection();
                        el.classList.add('filter-active');
                        collectionFilter.filterGrid();
                    }

                };
            }
        }

        nodelist = document.querySelectorAll('.ProductGrid--filter-fragrance-note li > div');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize');
                //let result = collectionFilter.findInProducts('data-product-fragrance-note',el.getAttribute('data-key'));
                //el.innerHTML+= " ("+result+")";
                el.onclick = function(e){
                    if(el.classList.contains('filter-active')){
                        el.classList.remove('filter-active');
                    }else{
                        collectionFilter.unsetSelection();
                        el.classList.add('filter-active');
                        collectionFilter.filterGrid();
                    }
                };
            }
        }*/


    }

    this.findInProducts = function(key,search) {
        let nodelist = document.querySelectorAll(this.classKey);
        let howMany = 0;
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            let hayStack = el.getAttribute(key).split(",");
            if(hayStack.includes(search)){
                howMany++;
            }
        }
        return howMany
    }

}

const collectionFilter = new CollectionFilterClass();
const FaqControlsClass = function (){
    console.log('FaqControls');
    let faqControls = document.querySelector('.FaqControls');
    let nodelist  = document.querySelectorAll('.AccordionItemTeaserVE');

    let categories = [];

    for (let i=0; i< nodelist.length; i++) {
        let el = nodelist[i];
        if(!categories.includes(el.getAttribute('data-category'))){
            categories.push(el.getAttribute('data-category'))
        }
    }

    for (let i=0; i< categories.length; i++) {
        faqControls.innerHTML+= '<div class="button btn-outline mr-md mb-md" >'+categories[i]+'</div>';
    }

    function runFilter(key){
        let nodelist  = document.querySelectorAll('.AccordionItemTeaserVE');
        for (let i=0; i< nodelist.length; i++) {
            if("" == key || key == nodelist[i].getAttribute('data-category')){
                nodelist[i].classList.remove('d-none');
            }else{
                nodelist[i].classList.add('d-none');
            }
        }
    }

    function unsetSelection(){

        let nodelist  = document.querySelectorAll('.FaqControls .button');
        for (let i=0; i< nodelist.length; i++) {
            nodelist[i].classList.remove('filter-active');
        }
    }


    nodelist  = document.querySelectorAll('.FaqControls .button');
    for (let i=0; i< nodelist.length; i++) {

        nodelist[i].onclick = function(e){
            console.log(e.currentTarget.innerHTML);

            if(e.currentTarget.classList.contains('filter-active')){
                runFilter("")
                unsetSelection();
            }else{
                unsetSelection();
                runFilter(e.currentTarget.innerHTML)
                e.currentTarget.classList.add('filter-active');

            }

        }
    }

    console.log(categories);

}

let faqControls = new FaqControlsClass();
const PurchaseFlowClass = function (targetFlow) {
    //console.log("PurchaseFlowClass");
    //console.log(targetFlow);

    function setSelected(el){

        let nodelist = targetFlow.querySelectorAll('.product-variant-selector-2021')

        for (let i=0; i< nodelist.length; i++) {
            nodelist[i].classList.remove('product-variant-selected')
        }
        el.classList.add('product-variant-selected')


        let productSelector = targetFlow.querySelector('.product-select')
        nodelist = productSelector.querySelectorAll('option')

        for (let i=0; i< nodelist.length; i++) {
            nodelist[i].removeAttribute('selected')
            if(el.getAttribute('data-value') == nodelist[i].getAttribute('value')){
                nodelist[i].setAttribute('selected','selected')
            }
        }
        let productId= targetFlow.getAttribute('data-product-id');

        if(true === isWholesale) {
            document.querySelector('#Product-' + productId + ' .product__price .price-item--compare-at').innerHTML = el.getAttribute('data-pricemoney')
            document.querySelector('#Product-' + productId + ' .product__price .price-item--regular').innerHTML = el.getAttribute('data-pricewholesalemoney')
        }else{
            document.querySelector('#Product-' + productId + ' .product__price .price-item--regular').innerHTML = el.getAttribute('data-pricemoney')
        }
        //document.querySelector('#product-selection-indicator').innerHTML = "Yo";
    }


    let nodelist = targetFlow.querySelectorAll('.quantity__button')
    for (let i=0; i< nodelist.length; i++) {
        nodelist[i].onclick = function(e){
            let quant = parseInt(targetFlow.querySelector('.quantity__input').value);
            let minAmount = 1
            if(isWholesale){
                minAmount = 6
            }

            if('minus'== e.currentTarget.getAttribute('name')){
                targetFlow.querySelector('.quantity__input').value = quant-minAmount
                if(quant-minAmount < minAmount){
                    targetFlow.querySelector('.quantity__input').value = minAmount
                }
            }else{
                targetFlow.querySelector('.quantity__input').value = quant+minAmount
            }
        }

    }

    let productAddToCartButton= targetFlow.querySelector('.product-add-to-cart-button');
    if(productAddToCartButton){
        productAddToCartButton.onclick = function(e){
            e.preventDefault();
            let useDropdown = e.currentTarget.getAttribute('data-use-dropdown');
            let quantity;
            let selectedVariant;
            if ('no' === useDropdown) {
                selectedVariant = targetFlow.querySelector('.product-select').value;
                quantity = targetFlow.querySelector('.quantity__input').value;

            }else {
                selectedVariant = e.currentTarget.getAttribute('data-variant-id');
                quantity = parseInt(targetFlow.querySelector('.purchase-form__quantity-select-indicator').innerHTML);
            }
            console.log(quantity,selectedVariant);
            AjaxCart.quickAddToCart(quantity,selectedVariant);
        }
    }

    nodelist = document.querySelectorAll('.product-purchase-flow .product-variant-selector-2021');
    for (let i=0; i< nodelist.length; i++) {
        let el = nodelist[i];
        if(!el.classList.contains('did-initialize')){
            el.classList.add('did-initialize')
            el.onclick = function(e){
                setSelected(e.currentTarget);
            }
        }
    }

}


class VariantSelectorClass {
    constructor() {
        console.log('VariantSelectorClass')
        let nodelist = document.querySelectorAll('.product-purchase-flow')
        for (let i=0; i< nodelist.length; i++) {this.buildSimpleSelectors(nodelist[i])}

    }

    buildSimpleSelectors(el){

        if (!el.classList.contains('did-initialize')) {
            el.classList.add('did-initialize')
            el.querySelector('.purchase-form__selector-options').addEventListener('change',(event) => {this.selectChangeEvent(event,el)})
            let simpleSelectors = document.createElement( 'div' )
            simpleSelectors.setAttribute('class','purchase-form__selector-options-inline ')
            let nodelist = el.querySelectorAll('.purchase-form__selector-options option')

            // clone the existing options
            for (let k = 0; k < nodelist.length; k++) {
                let optionHtml = nodelist[k].outerHTML.replace("<option","<div")
                optionHtml = optionHtml.replace("</option","</div")
                optionHtml = optionHtml.replace('class="','class="option-selector ')
                simpleSelectors.innerHTML+= optionHtml
            }
            el.querySelector('.purchase-form__selector').appendChild(simpleSelectors)


            el.querySelector('.purchase-form__quantity-select-plus').addEventListener('click',(event) => {this.upQuantity(event,el)})
            el.querySelector('.purchase-form__quantity-select-minus').addEventListener('click',(event) => {this.downQuantity(event,el)})

            let selectors = el.querySelectorAll('.option-selector')
            for (let k = 0; k < selectors.length; k++) {
                selectors[k].addEventListener('click',(event) => {this.selectorClick(event,el)})

                if (selectors[k].classList.contains('option-selected')) {
                    this.updatePricing(el, selectors[k])
                }
            }
        }
    }

    getAddToCart(el){
        let addToCartBtn = el.querySelector('button')
        if (!addToCartBtn) {
            addToCartBtn = document.querySelector('#product-add-to-cart-button')
        }
        return addToCartBtn
    }

    selectChangeEvent(e,el){
        this.unsetSelection(el)

        let currentNode = e.currentTarget.options[e.currentTarget.selectedIndex]
        this.getAddToCart(el).setAttribute('data-variant-id', currentNode.getAttribute('data-variant-id'))
        this.updatePricing(el,currentNode)
        el.querySelector('.option-selector[data-variant-id="'+currentNode.getAttribute('data-variant-id')+'"]').classList.add('option-selected')

    }

    upQuantity(e,el){
        let amount = 1
        if (isWholesale) {
            amount = 6
        }
        this.changeQuantity(el, amount)
    }

    downQuantity(e,el){
        let amount = -1
        if (isWholesale) {
            amount = -6
        }
        this.changeQuantity(el, amount)
    }

    selectorClick(e,el){
        this.unsetSelection(el)
        e.currentTarget.classList.add('option-selected')
        this.getAddToCart(el).setAttribute('data-variant-id', e.currentTarget.getAttribute('data-variant-id'))
        this.updatePricing(el, e.currentTarget)
        this.updateVariantImages(el, e.currentTarget)
        el.querySelector('.purchase-form__selector-options').value =  e.currentTarget.getAttribute('data-variant-id')
    }

    unsetSelection(el){
        let selectors = el.querySelectorAll('.option-selector');
        for (let k=0; k< selectors.length; k++) {
            selectors[k].classList.remove('option-selected');
        }
    }

    changeQuantity(el,dir){
        let quant = parseInt(el.querySelector('.purchase-form__quantity-select-indicator').innerHTML);

        quant = quant+dir;

        let minAmount = 1
        if(isWholesale){
            minAmount = 6
        }

        if(quant < 1){
            quant = minAmount;
        }
        if(quant > 100){
            quant = 100;
        }

        el.querySelector('.purchase-form__quantity-select-indicator').innerHTML = quant;
    }

    updateVariantImages(el,variantSelector){
        console.log('updateVariantImages '+variantSelector.getAttribute('data-variant-id'))
        dqsa('.pdp-variant-image')?.forEach((el) => {
            el.classList.add('opacity-0')
        })
        dqsa('.pdp-variant-image-'+variantSelector.getAttribute('data-variant-id'))?.forEach((el) => {
              el.classList.remove('opacity-0')
        })
    }

    updatePricing(el,variantSelector){
        // for PdP
        let priceTarget = el.querySelector('.price-item--regular');
        //console.log('updatePricing: ')
        //console.log(variantSelector)
        document.body.setAttribute('data-current-variant', variantSelector.getAttribute('data-variant-handle'))


        // if it is for a card update the card else update the body
        if(el.parentNode.classList.contains('product-card')){
            el.parentNode.setAttribute('data-current-variant', variantSelector.getAttribute('data-variant-handle'))
        }else{
            document.body.setAttribute('data-current-variant', variantSelector.getAttribute('data-variant-handle'))
        }

        // check if sale
        el.parentNode.classList.remove('variant-is-sale')
        if(variantSelector.getAttribute('data-variant-compare-at-price')){
            el.parentNode.classList.add('variant-is-sale')
        }


        if(priceTarget){
            if(true === isWholesale) {
                el.querySelector('.price-item--regular').innerHTML = variantSelector.getAttribute('data-pricewholesalemoney')
                el.querySelector('.price-item--compare-at').innerHTML = variantSelector.getAttribute('data-variant-price')
            }else{
                el.querySelector('.price-item--regular').innerHTML = variantSelector.getAttribute('data-variant-price')
                el.querySelector('.price-item--sale').innerHTML = variantSelector.getAttribute('data-variant-price')
            }
        }
        /*
        let priceTargetInButton = el.querySelector('.add-to-cart-price');
        if(priceTargetInButton){
            if(true === isWholesale) {
                priceTargetInButton.innerHTML = variantSelector.getAttribute('data-pricewholesalemoney')
            }else{
                priceTargetInButton.innerHTML = variantSelector.getAttribute('data-variant-price')
            }
        }*/
    }


}


const SuperSlideshow = function (el){
    console.log('new SuperSlideshow');
    let slides = el.querySelectorAll('.SuperSlideshowSlide');

    // fade or slide
    let transition = el.getAttribute('data-fx');

    let currentSlideId = 1;
    let slideshowWidth = 0;
    let lastSlideId = 1;
    let totalSlides = slides.length;
    let prevButton = el.querySelector('.SuperSlideshow__prev-button');
    let nextButton = el.querySelector('.SuperSlideshow__next-button');
    let pager = el.querySelector('.SuperSlideshow__pager');
    let pagers;


    let additionalPagers = [];
    let additionalPagerSelector =  el.getAttribute('data-additionalpager');
    if("" !== additionalPagerSelector){
        additionalPagers = document.querySelectorAll(additionalPagerSelector);
    }



    let autoPlay =  el.getAttribute('data-autoPlay');
    let paused = false;

    let scaleMode =  el.getAttribute('data-scaleMode');
    let slideshowMode =  el.getAttribute('data-slideshowMode');
    let slideIndicator = el.querySelector('.SuperSlideshow__slideIndicator');
    let controlWrapper = el.querySelector('.SuperSlideshow__control-wrapper');
    let slideShow = el.querySelector('.SuperSlideshow__slideshow');


    let interval = setInterval(
        function(){
            layout();
        }, 200
    )



    function layout(){
        let height = 0;
        for (let i= 0; i< slides.length; i++) {
            let slide = slides[i];
            if(slide.clientHeight > height){
                height = slide.clientHeight;
            }
        }


        slideshowWidth = el.clientWidth;
        if('full-height' === scaleMode){
            slideShow.style.height = '100%';
            el.setAttribute('data-scaling-by','full-height');
        }
        else if('auto-height' === scaleMode){
            for (let i=0; i< slides.length; i++) {
                let slide = slides[i];
                if(slide.classList.contains('current-slide')){
                    height = slide.clientHeight;
                    // add the control wrapper to the height
                    let vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                    if(el.classList.contains('is-product-slideshow') && vw < 992){


                        slideShow.style.height = height+'px';
                    }else{
                        slideShow.style.height = height+'px';
                    }
                }
            }
            el.setAttribute('data-scaling-by','auto-height');
        }
        else if(pagers && 'pager-over-image' === scaleMode || 'slideshow-slides-in-phone' === slideshowMode){
            slideShow.style.height =  height+'px';
            el.setAttribute('data-scaling-by','pager-over-image || slideshow-slides-in-phone');
        }
        else if(pagers && 'current-slide' === scaleMode){

            for (let i=0; i< slides.length; i++) {
                let slide = slides[i];
                if(slide.classList.contains('current-slide')){
                    height = slide.clientHeight
                    slideShow.style.height = height+'px'
                }
            }
            el.setAttribute('data-scaling-by','current-slide');
        }
        else if(pagers && 'in-page' === scaleMode){
            slideShow.style.height =  height+36+'px';
            el.setAttribute('data-scaling-by','in-page');
        }
        else if(pagers){
            let vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            let additionalHeight = 0;
            if(vw <  992){
                additionalHeight = 0;
            }
            slideShow.style.height = height+additionalHeight+'px';
            el.setAttribute('data-scaling-by','height additionalHeight');

        }else{

            slideShow.style.height = height+'px';
            el.setAttribute('data-scaling-by','height');
        }

        let currentInfo =  el.querySelector('.SuperSlideshowSlide.current-slide .SuperSlideshowSlide__info');
        let currentInfoWrapper =  el.querySelector('.SuperSlideshowSlide.current-slide .SuperSlideshowSlide__info-wrapper');

        if(currentInfo && currentInfoWrapper && 'vertical' != slideshowMode){
            //let wrapperPositionTopPadding = (currentInfoWrapper.clientHeight-currentInfo.clientHeight)/2;
            //let topPos = wrapperPositionTopPadding+currentInfo.clientHeight+45;
            height = height+30;
            // controlWrapper.setAttribute('style','top:'+height+'px');
        }
        // for quote slideshow
        if(null == currentInfo && 'vertical' != slideshowMode){
            height = height+30;
            // controlWrapper.setAttribute('style','top:'+height+'px');
        }



        // console.log(height);
    }


    function prev(){
        lastSlideId  = currentSlideId;
        if(currentSlideId > 1){
            currentSlideId--;
        }else{
            currentSlideId = totalSlides;
        }
        gotoSlide('prev');
    }

    function next(){
        lastSlideId  = currentSlideId;
        if(currentSlideId < totalSlides){
            currentSlideId++;
        }else{
            currentSlideId = 1;
        }
        gotoSlide('next');
    }

    function bindClickEvents(){
        if(prevButton){
            prevButton.onclick = function(e){
                paused = true;
                prev()
            };
            nextButton.onclick = function(e){
                paused = true;
                next()
            };
        }

    }
    bindClickEvents();

    function addPager(el){

        if(!pager){return false}
        let index = 1;
        for (let i=0; i< slides.length; i++) {
            if(index === 1 ){
                pager.innerHTML+= '<span class="current-pager" data-index="'+index+'" >&nbsp;</span>';
            }else{
                pager.innerHTML+= '<span data-index="'+index+'" >&nbsp;</span>';
            }
            index++;
        }

        pagers = el.querySelectorAll('.SuperSlideshow__pager > span');

        index = 1;
        for (let i = 0; i< pagers.length; i++) {
            pagers[i].onclick = function(e){
                lastSlideId  = currentSlideId;
                currentSlideId = e.currentTarget.getAttribute('data-index');
                if(lastSlideId < currentSlideId){
                    gotoSlide('next');
                }else{
                    gotoSlide('prev');
                }
            }
            index++;
        }
        if(slideIndicator){
            slideIndicator.innerHTML = currentSlideId+"/"+totalSlides;
        }

        console.log('additionalPager');
        console.log(additionalPagers);
        index = 1;
        for (let i = 0; i< additionalPagers.length; i++) {
            additionalPagers[i].onclick = function(e) {
                console.log('additionalPager click');
                lastSlideId = currentSlideId;
                currentSlideId = parseInt(e.currentTarget.getAttribute('data-index'));
                console.log(lastSlideId, currentSlideId);
                if (lastSlideId < currentSlideId) {
                    gotoSlide('next');
                } else {
                    gotoSlide('prev');
                }
                paused = true;
            }
            index++;
        }
    }
    addPager(el);

    function gotoSlide(dir){
        //console.log(dir,lastSlideId,currentSlideId,totalSlides);
        //console.log(initialText);
        gotoCurrentSlide(dir);
    }

    function getSlideByIndex(slideIndex){
        let index = 1;
        for (let i=0; i < slides.length; i++) {
            let slide = slides[i];

            if(index === parseInt(slideIndex)){
                return slide;
            }
            index++;
        }
    }

    function getPagerByIndex(slideIndex){
        let index = 1;
        for (let i=0; i < pagers.length; i++) {
            let pagerItem = pagers[i];
            if(index ===  parseInt(slideIndex)){
                return pagerItem;
            }
            index++;
        }
    }

    function getAdditionalPagerByIndex(slideIndex){
        let index = 1;
        for (let i=0; i < additionalPager.length; i++) {
            let pagerItem = additionalPager[i];
            if(index == slideIndex){
                return pagerItem;
            }
            index++;
        }
    }

    function getAdditionalPagerByIndex(slideIndex){
        let index = 1;
        for (let i=0; i < additionalPagers.length; i++) {
            let pagerItem = additionalPagers[i];
            if(index ===  parseInt(slideIndex)){
                return pagerItem;
            }
            index++;
        }
    }

    function gotoCurrentSlide(dir){
        //console.log(dir,currentSlideId);
        for (let i=0; i < pagers.length; i++) {
            pagers[i].classList.remove('current-pager');
        }

        if(additionalPagers && additionalPagers.length > 0){
            for (let i=0; i < additionalPagers.length; i++) {
                additionalPagers[i].classList.remove('current-pager');
            }
        }

        for (let i=0; i < slides.length; i++) {
            slides[i].classList.remove('current-slide');
        }
        let slide = getSlideByIndex(currentSlideId);
        let lastSlide = getSlideByIndex(lastSlideId);

        slide.classList.add('current-slide');

        el.setAttribute('data-currentSlide',currentSlideId);

        let nextSlideId = currentSlideId+1;
        let nextSlide =  getSlideByIndex(nextSlideId);
        // console.log(nextSlide,nextSlideId);
        if(nextSlide){
            nextSlide.classList.add('slide-preload');
        }

        if(pagers && pagers.length > 0) {
            let currentSlide = getPagerByIndex(currentSlideId);
            currentSlide.classList.add('current-pager');
        }

        if(additionalPagers && additionalPagers.length > 0) {
            //console.log("additional-pager",currentSlideId);
            let targetPager = getAdditionalPagerByIndex(currentSlideId);
            //console.log("targetPager");
            //console.log(targetPager);
            if(targetPager){
                targetPager.classList.add('current-pager')
            }
        }

        if(transition === 'slide'){
            //console.log("transition === 'slide'",lastSlide,slide);
            if('fixed-background-with-quotes' === slideshowMode) {
                fadeTransition(dir,lastSlide,slide);
            }
            else if('vertical' !== slideshowMode) {
                horizontalTransition(dir,lastSlide,slide);
            }else {
                verticalTransition(dir,lastSlide,slide)
            }
        }

        if(slideIndicator){
            slideIndicator.innerHTML = currentSlideId+"/"+totalSlides;
        }
    }

    swipeDetect(el,next,prev);
    //console.log(autoPlay,paused)
    if(autoPlay == 1){

        let autoPlayInterval = setInterval(function(){
            if(paused == false){

                next();
            }

        },4000);
    }


    function fadeTransition(dir,lastSlide,slide){
    }


    function verticalTransition(dir,lastSlide,slide){
        if(dir === 'next'){
            lastSlide.style.top = -slideshowWidth+'px';
            slide.classList.add('block-transition');
            slide.style.top = slideshowWidth+'px';
        }else{
            lastSlide.style.top = slideshowWidth+'px';
            slide.classList.add('block-transition');
            slide.style.top = -slideshowWidth+'px';
        }

        let timeout = setTimeout(function(){
            slide.classList.remove('block-transition');
            slide.style.top = 0+'px';
            clearTimeout(timeout);
        },20);
    }

    function horizontalTransition(dir,lastSlide,slide){
        if(dir === 'next'){
            lastSlide.style.left = -slideshowWidth+'px';
            slide.classList.add('block-transition');
            slide.style.left = slideshowWidth+'px';
        }else{
            lastSlide.style.left = slideshowWidth+'px';
            slide.classList.add('block-transition');
            slide.style.left = -slideshowWidth+'px';
        }

        let timeout = setTimeout(function(){
            slide.classList.remove('block-transition');
            slide.style.left = 0+'px';
            clearTimeout(timeout);
        },20);
    }
}

function buildStockists(){
    const stockists = []

    /*
    const stockists = [
      {region:'Alabama',name:'Illuminated',address:'2415 Montevallo Rd.Mountain Brook, AL 35223',website:'https://www.acandlebar.com'},
      {region:'National',name:'Illuminated',address:'2415 Montevallo Rd.Mountain Brook, AL 35223',website:'https://www.acandlebar.com'},
      {region:'International',name:'Illuminated',address:'2415 Montevallo Rd.Mountain Brook, AL 35223',website:'https://www.acandlebar.com'},
      {region:'Online',name:'Illuminated',address:'2415 Montevallo Rd.Mountain Brook, AL 35223',website:'https://www.acandlebar.com'},
      {region:'California',name:'Illuminated',address:'2415 Montevallo Rd.Mountain Brook, AL 35223',website:'https://www.acandlebar.com'},
      {region:'Alabama',name:'Illuminated',address:'2415 Montevallo Rd.Mountain Brook, AL 35223',website:'https://www.acandlebar.com'},
      {region:'Alabama',name:'Illuminated',address:'2415 Montevallo Rd.Mountain Brook, AL 35223',website:'https://www.acandlebar.com'},
    ]*/

    let stockistsCategories = ['National','International','Online'];
    let additionalCategories = [];

    function pullStores(key,returnType){
        let html = "";
        let count = 0;

        for (let i=0; i< stockists.length; i++) {
            let store = stockists[i];
            let card = document.createElement( 'div' );
            card.innerHTML = document.querySelector('#AddressCard').innerHTML;
            if(store.region === key){
                card.querySelector('.AddressCard__title').innerHTML = store.name;
                if("" !== store.address){
                    card.querySelector('.AddressCard__text').innerHTML  = store.address+'<br>';
                }

                if("" !== store.website){
                    let cleanUrl = store.website.replace('https://','');
                    cleanUrl = cleanUrl.replace('http://','');
                    cleanUrl = cleanUrl.replace('www.','');
                    cleanUrl = cleanUrl.replace('www','');
                    cleanUrl = cleanUrl.replace(/\/$/, "");
                    if(store.website.includes('https://www.')){
                        cleanUrl = store.website.replace('https://','');
                    }
                    card.querySelector('.AddressCard__url').innerHTML  = '<a href="https://'+cleanUrl+'" target="_blank">Website</a><br>';
                    count++;
                }
                html+=  card.innerHTML;
            }
        }

        if(returnType === 'count'){
            return count;
        }else{
            return html;
        }



    }


    function render(){


        let target = document.querySelector('.main-stockists__content');
        let template = document.querySelector('#AccordionItemTeaserVE');

        for (const property in stockistsCategories) {

            let dummy = document.createElement( 'div' );
            dummy.innerHTML = template.innerHTML;
            dummy.querySelector('h6').innerHTML = stockistsCategories[property]+'<span class="AccordionItemTeaserVE__store-count">'+pullStores(stockistsCategories[property],'count')+'</span>';

            dummy.querySelector('.AccordionItemTeaserVE__content').innerHTML = pullStores(stockistsCategories[property],'html');
            target.innerHTML+= dummy.innerHTML;
        }
        document.querySelector('.main-stockists__content').classList.add('Accordion');


        applicationJS.initializePage()
    }


    function fetchData(){

        if (typeof storesJSON === 'undefined'){
            return
        }
        let xhr = new XMLHttpRequest();
        xhr.overrideMimeType("application/json");
        xhr.open('GET',storesJSON);

        xhr.send(null);
        xhr.onreadystatechange = function () {
            var DONE = 4; // readyState 4 means the request is done.
            var OK = 200; // status 200 is a successful return.
            if (xhr.readyState === DONE) {
                if (xhr.status === OK) {
                    let jsonResponse = JSON.parse(xhr.responseText);
                    //console.log(jsonResponse);


                    for(let i = 0; i  < jsonResponse.length; i++){
                        //console.log(jsonResponse[i]);
                        //{region:'Alabama',name:'Illuminated',address:'2415 Montevallo Rd.Mountain Brook, AL 35223',website:'https://www.acandlebar.com'}
                        /*{
                          "Category": "Storefront",
                          "Master category": "Minnesota",
                          "Company": "Adirondack Coffee",
                          "Address1": "25469 Main St.",
                          "Address2": "",
                          "City": "Nisswa",
                          "Province": "Minnesota",
                          "Province Code": "MN",
                          "Country": "United States",
                          "Country Code": "US",
                          "Zip": 56468,
                          "Website": "https://lovemymug.com"
                        }*/

                        if(!stockistsCategories.includes(jsonResponse[i]["Master category"])  && !additionalCategories.includes(jsonResponse[i]["Master category"]) && "" !== jsonResponse[i]["Master category"]){
                            additionalCategories.push(jsonResponse[i]["Master category"]);
                        }

                        let address = "";
                        if("" !== jsonResponse[i].Address1){
                            address+=jsonResponse[i].Address1
                        }
                        if("" !== jsonResponse[i].Address2){
                            address+=" "+jsonResponse[i].Address2
                        }
                        if("" !== jsonResponse[i].City){
                            address+=",<br> "+jsonResponse[i].City
                        }
                        if("" !== jsonResponse[i].Province){
                            address+=", "+jsonResponse[i].Province
                        }
                        if("" !== jsonResponse[i].Zip){
                            address+=" "+jsonResponse[i].Zip
                        }
                        if("" !== jsonResponse[i].Country){
                            address+="<br>"+jsonResponse[i].Country
                        }

                        let store = {
                            region:jsonResponse[i]["Master category"],
                            name:jsonResponse[i].Company,
                            address:address,
                            website:jsonResponse[i].Website
                        }
                        stockists.push(store)
                    }
                    stockists.sort((a, b) => {
                        let fa = a.name.toLowerCase(),
                            fb = b.name.toLowerCase();

                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    });

                    additionalCategories.sort()
                    stockistsCategories = stockistsCategories.concat(additionalCategories);
                    render();
                }
            }
        }

    }
    fetchData()

}

buildStockists()

class Anecdote2024Class {



    constructor() {
        console.log('new Anecdote2024Class')
        this.decorate()
        this.styleButtons()

    }


    decorate() {

        let nodelist = document.querySelectorAll('.header__menu-item, .list-menu__item')
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-decorate__customamp')){
                el.innerHTML = el.innerHTML.replace('Anecdote&amp; Custom',"<span>Anecdote<span class='color-ultramarine'>&amp;</span> Custom</span>")
                el.classList.add('did-decorate__customamp')
            }
        }
        nodelist = document.querySelectorAll('.list-menu__item')
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-decorate__icon-star')){

                if("<span>Best Sellers</span>" == el.innerHTML.trim()){
                    el.classList.add('did-decorate__icon-star')
                    el.innerHTML+= "<svg class=\"icon-star\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 13 13\">\n" +
                        "                        <defs>\n" +
                        "                          <style>\n" +
                        "                            .icon-star .cls-1 {\n" +
                        "                              fill: none;\n" +
                        "                              stroke: #667fff;\n" +
                        "                              stroke-width: 1px;\n" +
                        "                            }\n" +
                        "                          </style>\n" +
                        "                        </defs>\n" +
                        "                        <g>\n" +
                        "                          <g >\n" +
                        "                            <line class=\"cls-1\" x1=\"6.5\" y1=\"0\" x2=\"6.5\" y2=\"13\"></line>\n" +
                        "                            <line class=\"cls-1\" x1=\".9\" y1=\"3.2\" x2=\"12.1\" y2=\"9.8\"></line>\n" +
                        "                            <line class=\"cls-1\" x1=\"12.1\" y1=\"3.3\" x2=\".9\" y2=\"9.7\"></line>\n" +
                        "                          </g>\n" +
                        "                        </g>\n" +
                        "                      </svg>"

                }
            }
        }


    }

    styleButtons() {
        let nodelist = document.querySelectorAll('.arrow-link')
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-decorate__arrow-link')){
                el.classList.add('did-decorate__arrow-link')
                el.innerHTML +=  '<svg class="arrow-link-arrow" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom: 0.5rem;"><path d="M10.1494 1.35718L15.1154 6.32333L10.1494 11.2893" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.333 6.35718L1.18262 6.35718" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
            }
        }

        nodelist = document.querySelectorAll('.button-circle')
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-decorate__button-circle')){
                el.classList.add('did-decorate__button-circle')
                el.innerHTML +=  '<svg class="button-circle-arrow" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-top: 0.3rem;"><path d="M10.1494 1.35718L15.1154 6.32333L10.1494 11.2893" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.333 6.35718L1.18262 6.35718" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
            }
        }
    }

}



const AjaxCartClass2024 = function () {


    let ajaxCartProductRecLogic = [
        { 39380107198579 : [39262302994547,39279858417779]},
        { 39376671178867 : [39262302994547,39279856025715]},
        { 39376671178867 : [39262302994547,39279856025715]},
        { 39262302994547 : [39376671178867,39279856025715]},
        { 39262304567411 : [39380107198579,39279858417779]},
        { 39262284972147 : [39376671178867,39279856025715]},
        { 39262303092851 : [39376671178867,39279858417779]},
        { 39262304665715 : [39380107198579,39279856025715]},
        { 39262285070451 : [39376671178867,39279856025715]},
        { 32088597954675 : [39380107198579,39279858417779]},
        { 32167058407539 : [39262302994547,39279858417779]},
        { 32167058440307 : [39262302994547,39279856025715]},
        { 32188524265587 : [32088597954675,39279856025715]},
        { 39279856025715 : [39279858417779,39376671178867]},
        { 39279858417779 : [39279856025715,39380107198579]}
    ]
    let closeXSvg = '<svg  data-id="x-icon.svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.51 20.51"><path d="M12,11.3l9.55-9.55L20.86,1l-9.55,9.55L1.77,1l-.71.71,9.55,9.55L1.06,20.84l.71.71L11.31,12l9.55,9.55.71-.71Z" transform="translate(-1.06 -1.04)" style="fill-rule:evenodd"/></svg>'




    let penIcon2 = '<svg class="pen-icon" width="96" height="13" viewBox="0 0 96 13" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '        <path d="M91.7458 5.24402L91.7458 7.7775" stroke="black"/>\n' +
        '        <path d="M84.3493 11.53L8.4396 11.53L8.4396 1.49019L66.9206 1.4902" stroke="black" stroke-linecap="round"\n' +
        '              stroke-linejoin="round"/>\n' +
        '        <path\n' +
        '            d="M8.43799 1.50865L2.44001 1.50865C1.81426 1.50865 1.31061 2.12106 1.31061 2.88193L1.31061 10.0824C1.31061 10.8433 1.81426 11.4557 2.44001 11.4557L8.43799 11.4557L8.43799 1.50865Z"\n' +
        '            stroke="black" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '        <path d="M94.6631 6.59204L84.4784 11.5769" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '        <path d="M84.4783 1.49011L94.6629 6.47498" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '        <path d="M35.3998 1.4897L84.3526 1.48974L82.775 3.98828L84.4783 6.50037L82.775 9.13424L84.4783 11.5769"\n' +
        '              stroke="black" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '    </svg>'

    let baseUrl = 'https://anecdotecandles.com/';
    let cart;
    let self = this;
    let freeShippingValue = 35;
    let freeGiftValue = 80;
    let freeGiftVariantId = 32150793486451;

    let cartToken = 0;

    let hideFreeGift = true;

    if (typeof freeShippingThreshold != "undefined") {
        freeShippingValue = freeShippingThreshold;
    }
    if (typeof freeGiftThreshold != "undefined") {
        freeGiftValue = freeGiftThreshold;
    }

    if (typeof enableFreegift != "undefined") {
        hideFreeGift = false
    }

    let hasSubscriptionInCart = false;


    let freeGiftIcon = '<svg  width="17px" height="17px" viewBox="0 0 9 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">   \n' +
        '    <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
        '        <g transform="translate(-36.000000, -121.000000)" fill="#000000" fill-rule="nonzero">\n' +
        '            <g transform="translate(36.000000, 120.000000)">\n' +
        '                <g transform="translate(0.000000, 1.000000)">\n' +
        '                    <path d="M8.625,2.25 L7.666875,2.25 C7.80186684,2.02302277 7.87372263,1.76408299 7.875,1.5 C7.875,0.671572875 7.20342712,0 6.375,0 C5.62038518,0.000552018035 4.91629575,0.379352127 4.5,1.00875 C4.08370425,0.379352127 3.37961482,0.000552018035 2.625,0 C1.79657288,0 1.125,0.671572875 1.125,1.5 C1.12627737,1.76408299 1.19813316,2.02302277 1.333125,2.25 L0.375,2.25 C0.167893219,2.25 0,2.41789322 0,2.625 L0,4.5 C0,4.70710678 0.167893219,4.875 0.375,4.875 L0.75,4.875 L0.75,7.875 C0.75,8.49632034 1.25367966,9 1.875,9 L7.125,9 C7.74632034,9 8.25,8.49632034 8.25,7.875 L8.25,4.875 L8.625,4.875 C8.83210678,4.875 9,4.70710678 9,4.5 L9,2.625 C9,2.41789322 8.83210678,2.25 8.625,2.25 Z M6.375,0.75 C6.78921356,0.75 7.125,1.08578644 7.125,1.5 C7.125,1.91421356 6.78921356,2.25 6.375,2.25 L4.875,2.25 C4.875,1.42157288 5.54657288,0.75 6.375,0.75 Z M1.875,1.5 C1.875,1.08578644 2.21078644,0.75 2.625,0.75 C3.45342712,0.75 4.125,1.42157288 4.125,2.25 L2.625,2.25 C2.21078644,2.25 1.875,1.91421356 1.875,1.5 Z M0.75,3 L4.125,3 L4.125,4.125 L0.75,4.125 L0.75,3 Z M1.5,7.875 L1.5,4.875 L4.125,4.875 L4.125,8.25 L1.875,8.25 C1.66789322,8.25 1.5,8.08210678 1.5,7.875 Z M7.5,7.875 C7.5,8.08210678 7.33210678,8.25 7.125,8.25 L4.875,8.25 L4.875,4.875 L7.5,4.875 L7.5,7.875 Z M8.25,4.125 L4.875,4.125 L4.875,3 L8.25,3 L8.25,4.125 Z" id="Shape"></path>\n' +
        '                </g>\n' +
        '            </g>\n' +
        '        </g>\n' +
        '    </g>\n' +
        '</svg>'

    function handleCheckoutButtonVisibility(jsonResponse){

        if(isWholesale){
            let discountFactor = 0.5;
            if(jsonResponse.items_subtotal_price*discountFactor/100 < 100) {
                return "The minimum order value for Wholesale is $100."
            }
            let quantityWarning = "";
            for(let i = 0; i  < jsonResponse.items.length; i++){
                console.log(jsonResponse.items[i].quantity,jsonResponse.items[i].quantity%6);
                if(0 !== jsonResponse.items[i].quantity %6){
                    quantityWarning+= "<span class='font-sm'>"+jsonResponse.items[i].title+' must be purchased in multiples of 6.<br></span>';
                }
            }
            if("" === quantityWarning){
                return true
            }else {
                return quantityWarning
            }
        }else{
            return true;
        }
    }


    function fetchThumbnails() {
        console.log("fetchThumbnails: -->")
        document.querySelectorAll('.AjaxCart__cart-item-image').forEach((el) => {
            if (!el.classList.contains('did__load-image')) {
                console.log(el.querySelector('a').getAttribute('href'))
                let xhr = new XMLHttpRequest()
                xhr.open('GET',el.querySelector('a').getAttribute('href'),true)
                xhr.send(null)
                xhr.onreadystatechange = function () {
                    let DONE = 4; // readyState 4 means the request is done.
                    let OK = 200; // status 200 is a successful return.
                    if (xhr.readyState === DONE) {
                        if (xhr.status === OK) {
                            el.classList.add("did__load-image")
                            console.log("fetchThumbnails Done "+el.getAttribute('data-variant-id'))
                            let html = document.createElement('html')
                            html.innerHTML = xhr.responseText;
                            //let thumbnailData = html.querySelector("#thumbnail-data img[data-variant-id='"+el.getAttribute('data-variant-id')+"']")
                            let thumbnailData= html.querySelector("#thumbnail-data")
                            if(thumbnailData){
                                let dummy = document.createElement('div')
                                dummy.innerHTML =  html.querySelector("#thumbnail-data").innerHTML
                                let thumbnailHtml = dummy.querySelector("img[data-variant-id='"+el.getAttribute('data-variant-id')+"']")
                                el.querySelector('a').innerHTML = thumbnailHtml.outerHTML
                            }

                        }
                    }
                }
            } 
        })
    }

    function initializeCart() {
        console.log('initializeCart AjaxClass 2024')
        cart = document.createElement( 'div' )
        cart.setAttribute('id','AjaxCart')

        cart.innerHTML = '<div class="AjaxCart__overlay"></div><div class="AjaxCart__sidebar"></div>'
        document.body.append(cart)

        let freeshippingWording = 'You are $'+freeShippingValue+' away from Free Shipping';


        let sidebar =  cart.querySelector(".AjaxCart__sidebar");
        sidebar.innerHTML+= '<div class="AjaxCart__header width-100"><span class="AjaxCart__header-inner">Cart <span class="AjaxCart__num-items" ></span><span class="AjaxCart__free-shipping-top" >'+freeshippingWording+'</span></span><div class="AjaxCart__close" >'+closeXSvg+'</div></div>';
        sidebar.innerHTML+=
            '<div class="AjaxCart__free-shipping d-none" >' +
            '<div class="AjaxCart__free-shipping-bar" ><div class="AjaxCart__free-shipping-bar-progress" ></div></div>'+
            '<div class="AjaxCart__free-shipping-below-bar" >Unlock free domestic shipping at $'+freeShippingValue+'</div>'+
            '</div>';

        // for product pages
        let freeshippingNotification = document.querySelector('#pdp-freeshipping-notification');
        if(freeshippingNotification){
            freeshippingNotification.innerHTML = "<i>"+freeshippingWording+"</i>";
        }

        let freeGiftClass = '';
        if(true === hideFreeGift){
            freeGiftClass = 'AjaxCart__free-gift-blocked';
        }
        sidebar.innerHTML+=
            '<div class="AjaxCart__free-gift '+freeGiftClass+'" >' +
            '<div class="AjaxCart__free-gift-message" ><span class="pr-sm position-relative" style="width:40px" ><span class="position-absolute">'+freeGiftIcon+'</span></span><span>FREE gift with purchase over $'+freeGiftValue+'</span></div>' +
            '<div class="AjaxCart__free-gift-offer" >'+freeGiftContent()+'</div>' +
            '</div>';

        sidebar.innerHTML+= '<div class="AjaxCart__items"></div>';
        sidebar.appendChild(createElement('div',{'class':'AjaxCart__footer'}));



        // Route Code Edited 11/06/2023
        sidebar.querySelector(".AjaxCart__footer").appendChild(createElement('div',{'class':'route-div pt-md', 'data-subtotal-ref':'AjaxCart__subtotal-amount'}));
        // Route Code End
        self.addRouteListener()

        sidebar.querySelector(".AjaxCart__footer").appendChild(createElement('div',{'id':'AjaxCart__giftnote' }))

        sidebar.querySelector(".AjaxCart__footer").appendChild(createElement('div',{'class':'AjaxCart__footer-message portrait-regular-italic','innerHTML':'Shipping, taxes, and discount codes calculated at checkout.'}))
        sidebar.querySelector(".AjaxCart__footer").appendChild(createElement('div',{'class':'AjaxCart__footer-wholesale-message font-md text-left d-none color-deep-red','innerHTML':''}))
        sidebar.querySelector(".AjaxCart__footer").appendChild(createElement('a', {
                'class': 'AjaxCart__checkout-button button btn-black width-100',
                'innerHTML': '<span>Checkout <svg class="large-arrow" width="46" height="33" viewBox="0 0 46 33" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '                                <path d="M29.5393 31.9255L45.2219 16.4252L29.5393 0.925537" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>\n' +
                    '                                <path d="M42.7512 16.3196L1.22192 16.3196" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>\n' +
                    '                            </svg></span>',
                'href': '/checkout'
            }))
        sidebar.querySelector(".AjaxCart__checkout-button").appendChild(createElement('div',{'class':'AjaxCart__subtotal'}))
        sidebar.querySelector(".AjaxCart__subtotal").appendChild(createElement('div',{'class':'AjaxCart__subtotal-headline portrait-regular-italic font-md-alt','innerHTML':'Subtotal'}))
        sidebar.querySelector(".AjaxCart__subtotal").appendChild(createElement('div',{'class':'AjaxCart__subtotal-amount bolo-grotesk-regular font-lg '}))
        self.drawCart()

        let cartButtonList =  document.querySelectorAll('.cart-button');
        for (let i=0; i< cartButtonList.length; i++) {
            let el = cartButtonList[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize')
                el.onclick = function(e){
                    e.preventDefault();
                    AjaxCart.openCart();
                    return false;
                }
            }
        }


        function closeEvent(e){
            e.preventDefault();
            AjaxCart.closeCart();
            return false;
        }

        cart.querySelector('.AjaxCart__overlay').onclick = function(e){
            closeEvent(e);
        }

        cart.querySelector('.AjaxCart__close').onclick = function(e){
            closeEvent(e);
        }

        cart.querySelector('.AjaxCart__checkout-button').onclick = function(e){
            console.log('AjaxCart__checkout-button');
            self.updateCheckoutUrl();
            //window.location =  document.querySelector('.AjaxCart__checkout-button').getAttribute('href');
        }


        let nodelist = document.querySelectorAll('.add-to-cart-button');
        for (let i = 0; i< nodelist.length; i++) {
            nodelist[i].onclick = function(e){
                let items = [];
                let item = {quantity:e.currentTarget.getAttribute('data-variant-quantity'),id:e.currentTarget.getAttribute('data-variant-id')};
                items.push(item);
                AjaxCart.add(items);
            };
        }
    }

    this.addRouteListener = function(item) {


        let listener = setInterval(function(){
            let routeContainer = document.querySelector('.pw-variant-optimal-container')
            if(routeContainer &&  !routeContainer.classList.contains('route-container-initialized-for-anecdote-candles')){
                routeContainer.classList.add('route-container-initialized-for-anecdote-candles')
                if(routeContainer.querySelector('.pw-title span')){
                   routeContainer.querySelector('.pw-title').innerHTML = '<div class="route-container-label" >Optional</div>'+routeContainer.querySelector('.pw-title').innerHTML
                   routeContainer.querySelector('.pw-title span').innerHTML = 'Route Package Protection <br>& Carbon-Neutral Shipping'
                   //routeContainer.querySelector('.pw-title').innerHTML+= '<div class="pt-sm font-xs">Protection against loss, theft, or damage in transit and instant resolution.</div>'
                }

            }
        },400)
    }


    this.renderCartItem = function(item) {

        // shipping protection by route
        if(40346975568006=== item.id){
            return false
        }

        let cartItem = new CartItem2024Class()
        cartItem.item = item
        cartItem.render()
        //console.log(item)
        if(item.properties && 'undefined' !== typeof item.properties.shipping_interval_unit_type){
            console.log('shipping_interval_unit_type'+ typeof item.properties.shipping_interval_unit_type)
            hasSubscriptionInCart = true;
        }
        cart.querySelector('.AjaxCart__items').append(cartItem.html);
    }





    function renderFreeGift(subtotal,freeGiftIsInCart){

        console.log('renderFreeGift'+subtotal,freeGiftIsInCart);

        if(freeGiftIsInCart === true){
            cart.querySelector('.AjaxCart__free-gift-message').classList.add('d-none');
            cart.querySelector('.AjaxCart__free-gift-offer').classList.add('d-none');
            if(subtotal <= freeGiftValue){
                let item ={};
                item[freeGiftVariantId] = 0;
                AjaxCart.update(item);
            }
        }
        else if(subtotal >= freeGiftValue){
            cart.querySelector('.AjaxCart__free-gift-message').classList.add('d-none');
            cart.querySelector('.AjaxCart__free-gift-offer').classList.remove('d-none');
        }else{
            cart.querySelector('.AjaxCart__free-gift-message').classList.remove('d-none');
            cart.querySelector('.AjaxCart__free-gift-offer').classList.add('d-none');
        }
    }

    function renderProductRecs(cartItems){

        let xhr = new XMLHttpRequest();
        xhr.overrideMimeType("application/json");
        xhr.open('GET','/products.json?limit=250',true);
        xhr.send(null);
        xhr.onreadystatechange = function () {
            let DONE = 4; // readyState 4 means the request is done.
            let OK = 200; // status 200 is a successful return.
            if (xhr.readyState === DONE) {

                if (xhr.status === OK) {
                    let jsonResponse = JSON.parse(xhr.responseText);
                    console.log("renderProductRecs: -->");
                    //console.log(jsonResponse);
                    if(jsonResponse.products.length > 0){
                        applyRecommendations(cartItems,jsonResponse.products);
                    }
                }
            }
        }
        return false;
    }


    function applyRecommendations(cartItems,products){
        let productRecs =  document.querySelector('#AjaxCart__product-recs');
        if(productRecs){
            productRecs.parentNode.removeChild(productRecs);
        }

        let itemHtml  = document.createElement( 'div' );
        itemHtml.setAttribute('id','AjaxCart__product-recs');
        itemHtml.innerHTML =
            '<div class="AjaxCart__product-recs" >' +
            '<div class="AjaxCart__product-recs-preheadline">Recommended</div>' +
            '<div class="AjaxCart__product-recs-headline">You May Also Like</div>' +
            '<div class="AjaxCart__product-recs-products"></div>' +
            '</div>';
        cart.querySelector('.AjaxCart__items').append(itemHtml);

        console.log('applyRecommendations');
        //console.log(ajaxCartProductRecLogic);
        let recommendations = [];
        let recommendationsIds = [];
        for(let i = 0; i  < cartItems.length; i++){

            let recommendation = findRecommendation(cartItems[i].variant_id);
            if(recommendation){
                for (const property in recommendation) {
                    for(let k = 0; k  < recommendation[property].length; k++){
                        let recommendationVariant = findVariant(recommendation[property][k],products);
                        console.log(recommendationVariant.id,recommendationsIds.indexOf(recommendationVariant.id));

                        if(recommendationVariant && recommendations.length < 2
                            && !isInCart(recommendationVariant.id,cartItems)
                            && recommendationsIds.indexOf(recommendationVariant.id) === -1){
                            recommendations.push(recommendationVariant);
                            recommendationsIds.push(recommendationVariant.id);
                        }
                    }
                }
            }
        }
        //console.log(recommendations);

        for(let i = 0; i  < recommendations.length; i++){
            let variant = recommendations[i];
            let itemHtml  = document.createElement( 'div' );
            itemHtml.innerHTML = renderProductRecommendation(variant,products);
            cart.querySelector('.AjaxCart__product-recs').append(itemHtml);
        }
    }


    function addGiftNote(jsonResponse){

        let note = "";
        let noteHtml = ""
        if(jsonResponse.hasOwnProperty('note')){
            note = jsonResponse.note;
        }

        let gitftnoteNode = document.querySelector('#AjaxCart__giftnote')
        if('null' == note || null == note || 'null' == typeof(note) ){
            note = "";
        }

        noteHtml =
            "<div class='AjaxCart__giftnote-display'>" +
                "<div class='AjaxCart__giftnote-display-left '>" +
                    "<div class='bolo-grotesk-semi-bold font-xs text-uppercase pt-xs pb-xs'>Your gift note</div>"
                        +"<div class='AjaxCart__giftnote-edit  portrait-regular-italic' tabindex='0' >Edit</div>"+
                "</div>" +
                "<div class='AjaxCart__giftnote-display-right fancy-vertical-scroll'>" +
                    "<div class='AjaxCart__giftnote-display-text font-sm' >"+note+"</div>" +
                "</div>" +
            "</div>"

        noteHtml+=
            '<div class="d-flex AjaxCart__giftnote-controls">' +
                '<div class=" bolo-grotesk-semi-bold font-xs text-uppercase pt-xs pb-xs">' +
                    '<span class="AjaxCart__giftnote--hide-when-edit-open">Add </span>gift note' +
                '</div>'+
                '<div class="AjaxCart__giftnote-edit cursor-pointer text-underline pl-lg"  tabindex="0" >'+penIcon2+'</div>'+
                '<div class="AjaxCart__giftnote-edit-close cursor-pointer "  tabindex="0" >'+closeXSvg+'</div>'+
            '</div>'
        noteHtml+=
            "<div id='AjaxCart__giftnote-edit-interface' class='AjaxCart__giftnote-edit-interface d-none' >" +
                "<textarea id='AjaxCart__giftnote-content' placeholder='Your gift note text' class='fancy-vertical-scroll pr-md' >"+note+"</textarea>" +
                "<div class='button btn-sm btn-outline btn-xs btn-black AjaxCart__giftnote-edit-interface-save event-click-binds-saveGiftNote'  ><span class='AjaxCart__save-giftnote' >Save</span><span  class='AjaxCart__update-giftnote' >Update</span></div>" +
            "</div>";

        gitftnoteNode.innerHTML = '<div class="AjaxCart__giftnote-inner  ">'+noteHtml+'</div>'

        if(note.length > 0){
            gitftnoteNode.querySelector('.AjaxCart__giftnote-inner').classList.add("AjaxCart__giftnote-has-giftnote")
        }

        document.querySelector('.AjaxCart__giftnote-edit-interface-save').addEventListener('click',(event) => {
            AjaxCart.saveGiftNote()
        })

        document.querySelector('.AjaxCart__giftnote-edit-close').addEventListener('click',(event) => {
            document.getElementById("AjaxCart__giftnote-edit-interface").classList.add('d-none')
            document.querySelector(".AjaxCart__giftnote-inner").classList.remove('AjaxCart__giftnote--edit-open')
        })
        let nodelist =  document.querySelectorAll('.AjaxCart__giftnote-edit')
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize')
                el.addEventListener('click',(event) => {
                    AjaxCart.editGiftNote()
                })
            }
        }
    }

    this.editGiftNote = function(){
        console.log("editGiftNote");
        document.getElementById("AjaxCart__giftnote-edit-interface").classList.remove('d-none');
        document.querySelector("#AjaxCart__giftnote-edit-interface textarea").focus();
        document.querySelector(".AjaxCart__giftnote-inner").classList.add('AjaxCart__giftnote--edit-open');
    }

    this.saveGiftNote = function(){
        let data = { note:  document.getElementById("AjaxCart__giftnote-content").value}
        let xhr = new XMLHttpRequest();
        xhr.open('POST','/cart/update.js',true);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.send(JSON.stringify(data));
        xhr.onreadystatechange = function () {
            let DONE = 4; // readyState 4 means the request is done.
            let OK = 200; // status 200 is a successful return.
            if (xhr.readyState === DONE) {

                if (xhr.status === OK) {
                    let jsonResponse = JSON.parse(xhr.responseText);
                    console.log("saveGiftNote: -->");
                    AjaxCart.drawCart();
                    self.openCart()
                    /*
                    applicationJS.displayInModal("<div class='d-flex justify-content-center flex-direction-column align-items-center'><h5 class=\"headline-2 pb-xl color-golden-brown text-center\">\n" +
                        "      Your note was saved.\n" +
                        "    </h5><button onclick=\"applicationJS.closeOverlayModal()\"  class=\"button btn-sm btn-outline mt-lg mb-lg \">Got it</button></div>",'above-cart')
                    */
                }
                if (xhr.status === 422) {
                    alert('Error occured');
                }

            }
        }
    }





    function renderProductRecommendation(variant,products){

        let product = findProduct(variant.product_id,products);
        //console.log(product);
        let featuredImage = "";
        if(variant.featured_image.src){
            featuredImage = '<img src="'+variant.featured_image.src+'" class="img-fluid">';
        }

        return  '<div class="AjaxCart__recommend-item" >' +
            '<div class="d-flex pt-md  ">'+
            '<div class="AjaxCart__cart-item-image">' +
            '<a href="'+baseUrl+'products/'+product.handle+'?variant='+variant.id+'" >' +
            featuredImage +
            '</a>' +
            '</div>' +
            '<div class="AjaxCart__cart-item-info">' +
            '<a href="'+baseUrl+'products/'+product.handle+'?variant='+variant.id+'" class="d-block color-primary ">'+product.title+'<br>'+variant.title+'</a>' +
            '<div class="AjaxCart__recommend-item-price d-flex pb-md pt-sm">$'+variant.price+'</div>'+
            '<div class="width-100 text-left">' +
            '<div onclick="AjaxCart.quickAddToCart(1,'+variant.id+')" class="cursor-pointer btn btn-outline">Add to Cart</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

    }

    function isInCart(variantId,cartItems){
        for(let i = 0; i  < cartItems.length; i++){
            if(variantId === cartItems[i].variant_id){
                return true;
            }
        }
        return false;
    }

    function findRecommendation(variantId){
        for(let i = 0; i  < ajaxCartProductRecLogic.length; i++){
            let recommendation = ajaxCartProductRecLogic[i];
            for (const property in recommendation) {
                if(parseInt(variantId) === parseInt(property)){
                    return recommendation;
                }
            }
        }
        return false;
    }

    function findVariant(variantId,products){
        for(let i = 0; i  < products.length; i++){
            //console.log(products[i]);
            for(let k = 0; k  < products[i].variants.length; k++) {
                // console.log(products[i].variants[k].id);
                if(variantId === products[i].variants[k].id && true === products[i].variants[k].available){
                    return  products[i].variants[k];
                }
            }
        }
        return false;
    }

    function findProduct(productId,products){
        for(let i = 0; i  < products.length; i++){
            //console.log(products[i]);
            if(productId === products[i].id){
                return  products[i];
            }

        }
        return false;
    }


    this.quickAddToCart = function(quant,variantId){
        let items = [];
        let item = {quantity:quant,id:variantId};
        items.push(item);

        AjaxCart.add(items);
    }

    this.addToCartAndCheckoutWithDiscount = function(items,discountCode){

        if("" !== discountCode){
            setCookie("discountCode_"+domainKey,discountCode,365);
        }


        let message = document.createElement( 'div' );
        message.setAttribute('id','MessageOverlay');
        message.innerHTML = '<div class="MessageOverlay__overlay"><div class="css-spinner"></div><div class="MessageOverlay__message font-lg pt-md">Adding items to your cart</div></div>';
        message.innerHTML+= '';

        document.body.append(message);


        // let items = [{quantity:quant,id:variantId}];

        let xhr = new XMLHttpRequest();
        xhr.open('POST','/cart/add.js',true);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.send(JSON.stringify({items:items}));
        xhr.onreadystatechange = function () {
            let DONE = 4; // readyState 4 means the request is done.
            let OK = 200; // status 200 is a successful return.
            if (xhr.readyState === DONE) {

                if (xhr.status === OK) {
                    let jsonResponse = JSON.parse(xhr.responseText);
                    console.log("add: -->");
                    console.log(jsonResponse);
                    if(jsonResponse.items.length > 0){
                        self.updateCheckoutUrl();
                        window.location = document.querySelector('.AjaxCart__checkout-button').getAttribute('href');
                    }
                }
                if (xhr.status === 422) {
                    let jsonResponse = JSON.parse(xhr.responseText);
                    alert(jsonResponse.description);
                    message.parentNode.removeChild(message);
                }

            }
        }

    }


    this.updateCheckoutUrl = function(){
        console.log('hasSubscriptionInCart '+hasSubscriptionInCart);

        let discountSlug = "";
        if(typeof getCookie('discountCode_'+domainKey) != 'undefined' && "" !== getCookie('discountCode_'+domainKey)){
            discountSlug = "?discount="+getCookie('discountCode_'+domainKey);
            setCookie("discountCode_"+domainKey,"",365);
        }

        if(true === hasSubscriptionInCart){
            document.querySelector('.AjaxCart__checkout-button').setAttribute('href',self.buildCheckoutUrl()+discountSlug);
        }else{
            document.querySelector('.AjaxCart__checkout-button').setAttribute('href','https://anecdotecandles.com/checkout'+discountSlug);
        }
    }

    function freeGiftContent(){
        return ""
        /*
        return '<div id="AjaxCart__free-gift-product" class="">' +
            '<div   class="AjaxCart__freegift-item">' +
            '<div class="width-100">You unlocked your FREE Gift!</div>'+
            '<div class="d-flex pt-md  ">'+
            '<div class="AjaxCart__cart-item-image">' +
            '<a href="'+baseUrl+'/products/activity-kit?variant=32150793486451">' +
            '<img src="https://cdn.shopify.com/s/files/1/0077/9966/8851/products/image.png?v=1608652172" class="img-fluid">' +
            '</a>' +
            '</div>' +
            '<div class="AjaxCart__cart-item-info">' +
            '<a href="'+baseUrl+'/products/activity-kit?variant=32150793486451" class="d-block color-primary pb-md">Activity Book</a>' +
            '<div class="width-100 text-left"><div onclick="AjaxCart.quickAddToCart(1,32150793486451)" class="cursor-pointer btn  btn-outline">Add to Cart</div></div>' +
            '</div>' +
            '</div>' +
            '</div>'+
            '</div>'*/

    }

    function renderFreeShipping(subtotal){
        let amountLeft = freeShippingValue-subtotal;
        let percentDone = ((subtotal/freeShippingValue)*100).toFixed(0);
        //console.log(percentDone);
        let freeshippingWording = '$'+amountLeft.toFixed(0)+' away from Free Shipping';

        if(subtotal >= freeShippingValue){
            freeshippingWording = "You unlocked free shipping!";
            cart.querySelector('.AjaxCart__free-shipping-bar').classList.add('d-none');
            cart.querySelector('.AjaxCart__free-shipping-top').innerHTML = "You unlocked Free Shipping!";
            cart.querySelector('.AjaxCart__free-shipping-below-bar').innerHTML = "";
            cart.querySelector('.AjaxCart__free-shipping-below-bar').classList.add('d-none');
            cart.querySelector('.AjaxCart__free-shipping-bar-progress').setAttribute('style','width:0');
            cart.querySelector('.AjaxCart__free-shipping-bar-progress').innerHTML = '';
        }else{

            cart.querySelector('.AjaxCart__free-shipping-bar').classList.remove('d-none');
            cart.querySelector('.AjaxCart__free-shipping-top').innerHTML = freeshippingWording;
            cart.querySelector('.AjaxCart__free-shipping-below-bar').innerHTML = "Unlock free shipping at $"+freeShippingValue;
            cart.querySelector('.AjaxCart__free-shipping-below-bar').classList.remove('d-none');
            cart.querySelector('.AjaxCart__free-shipping-bar-progress').setAttribute('style','width:'+percentDone+'%');
            cart.querySelector('.AjaxCart__free-shipping-bar-progress').innerHTML = percentDone+'%';
        }

        // for product pages
        let freeshippingNotifications = document.querySelectorAll('.purchase-flow-freeshipping-notification');
        if(freeshippingNotifications){
            for(let i = 0; i  < freeshippingNotifications.length; i++){
                freeshippingNotifications[i].innerHTML = freeshippingWording;
            }

        }

    }

    this.getGALinker = function(){
        // Build the ga_linker param for the URL generator\
        //console.log(ga.get('linkerParam'));
        try {
            return [ga.getAll()[0].get('linkerParam')];
        } catch (e) {
            return [];
        }
    }

    this.buildCheckoutUrl = function(){
        // Build the Checkout URL for subscriptions
        return 'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=anecdote-candles.myshopify.com&cart_token='+cartToken+'&'+self.getGALinker();
    }

    this.renderCart = function(jsonResponse) {
        hasSubscriptionInCart = false;
        cart.querySelector('.AjaxCart__num-items').innerHTML = '('+jsonResponse.item_count+')';

        if(document.querySelector('.cart-count-bubble')){
            document.querySelector('.cart-count-bubble').innerHTML = jsonResponse.item_count;
        }

        let discountFactor = 1;

        let subtotal = jsonResponse.items_subtotal_price*discountFactor/100;
        cart.querySelector('.AjaxCart__subtotal-amount').innerHTML = '$'+subtotal;
        cart.querySelector('.AjaxCart__items').innerHTML = '';

        let freeGiftIsInCart = false;
        for(let i = 0; i  < jsonResponse.items.length; i++){
            //console.log(jsonResponse.items[i].variant_id,jsonResponse.items[i].quantity);
            self.renderCartItem(jsonResponse.items[i]);
            if(freeGiftVariantId === jsonResponse.items[i].id){
                freeGiftIsInCart = true;
            }
        }
        renderFreeShipping(jsonResponse.items_subtotal_price*discountFactor/100);
        renderFreeGift(jsonResponse.items_subtotal_price*discountFactor/100,freeGiftIsInCart);

        let wholesaleMessage = handleCheckoutButtonVisibility(jsonResponse)
        if(true === wholesaleMessage){
            cart.querySelector('.AjaxCart__footer-wholesale-message').innerHTML = "";
            cart.querySelector('.AjaxCart__checkout-button').classList.remove('d-none');
        }else{

            cart.querySelector('.AjaxCart__checkout-button').classList.add('d-none');
            cart.querySelector('.AjaxCart__footer-wholesale-message').classList.remove('d-none');
            cart.querySelector('.AjaxCart__footer-wholesale-message').innerHTML = wholesaleMessage;
        }


        self.updateCheckoutUrl();

        if(jsonResponse.items.length === 0){
            cart.querySelector('.AjaxCart__items').innerHTML = "<div class='AjaxCart__cart-item '><div class='text-center width-100'>Your cart is empty. <a href='https://https://anecdotecandles.com/collections/candles-accessories'>Start shopping now</a></div></div>";
        }else{
            renderProductRecs(jsonResponse.items);
        }
        addGiftNote(jsonResponse)
        //fetchThumbnails()
    }

    this.update = function(myItems) {
        let xhr = new XMLHttpRequest();
        xhr.open('POST','/cart/update.js',true);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.send(JSON.stringify({updates:myItems}));
        xhr.onreadystatechange = function () {
            let DONE = 4; // readyState 4 means the request is done.
            let OK = 200; // status 200 is a successful return.
            if (xhr.readyState === DONE) {
                if (xhr.status === OK) {
                    let jsonResponse = JSON.parse(xhr.responseText);
                    console.log("update: -->");
                    console.log(jsonResponse);
                    AjaxCart.drawCart();
                    self.openCart();

                }
            }
        }
        return false;
    }

    this.add = function(myItems){
        // let items = [];
        // let item = {quantity:quant,id:variantId};
        // items.push(item);

        function transferFailed(evt) {
            console.log("An error occurred while transferring the file.");
        }

        let xhr = new XMLHttpRequest()
        xhr.addEventListener("error", transferFailed);
        xhr.open('POST','/cart/add.js',true)
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
        xhr.onreadystatechange = function () {
            let DONE = 4; // readyState 4 means the request is done.
            let OK = 200; // status 200 is a successful return.
            if (xhr.readyState === DONE) {

                if (xhr.status === OK) {
                    let jsonResponse = JSON.parse(xhr.responseText);
                    console.log("add: -->");
                    console.log(jsonResponse);
                    if(jsonResponse.items.length > 0){
                        AjaxCart.drawCart();
                        self.openCart();
                    }
                }
            }
        }
        xhr.send(JSON.stringify({items:myItems}))
        return false;
    }

    this.drawCart = function(){
        let xhr = new XMLHttpRequest();
        xhr.overrideMimeType("application/json");
        xhr.open('GET','/cart.js',true);
        xhr.send(null);
        xhr.onreadystatechange = function () {
            let DONE = 4; // readyState 4 means the request is done.
            let OK = 200; // status 200 is a successful return.
            if (xhr.readyState === DONE) {

                if (xhr.status === OK) {
                    let jsonResponse = JSON.parse(xhr.responseText);
                    console.log("Draw cart: -->");
                    console.log(jsonResponse);
                    cartToken = jsonResponse.token;
                    AjaxCart.renderCart(jsonResponse);

                }
            }
        }
        return false;
    }

    this.cartClickEvent = function(){
        //AjaxCart__checkout-button button width-100

    }

    this.openCart = function(){
        console.log('openCart');
        cart.classList.add('AjaxCart__open');
        document.body.classList.add('in-modal');
    }

    this.closeCart = function(){
        console.log('closeCart');
        cart.classList.remove('AjaxCart__open')
        document.body.classList.remove('in-modal')
        if(document.body.getAttribute('data-closeCartEvent')){
            eval(document.body.getAttribute('data-closeCartEvent'))
            document.body.setAttribute('data-closeCartEvent','')
        }
    }
    initializeCart();

    let vh = 0;

    function cartLayout(){
            vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
            //console.log(vh ,cart.querySelector('.AjaxCart__header').offsetHeight,cart.querySelector('.AjaxCart__footer').offsetHeight,cart.querySelector('.AjaxCart__free-shipping').offsetHeight,cart.querySelector('.AjaxCart__free-gift').offsetHeight)
            let height = vh -cart.querySelector('.AjaxCart__header').offsetHeight-cart.querySelector('.AjaxCart__footer').offsetHeight-cart.querySelector('.AjaxCart__free-shipping').offsetHeight-cart.querySelector('.AjaxCart__free-gift').offsetHeight;
            cart.querySelector('.AjaxCart__items').setAttribute('style','height:'+height+'px');
    }


    let cartLayoutInterval = setInterval(function(){
        cartLayout()
    },800)

    function createElement(key,options) {

        let newElement = document.createElement( key );
        if(options.class){
            newElement.setAttribute('class',options.class);
        }
        if(options.id){
            newElement.setAttribute('id',options.id);
        }
        if(options.innerHTML){
            newElement.innerHTML= options.innerHTML;
        }
        if(options.href){
            newElement.href= options.href;
        }
        return newElement;

    }

}


class CartItem2024Class {

    freeGiftVariantId = 0
    item
    html
    closeXSvg = '<svg  data-id="x-icon.svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.51 20.51"><path d="M12,11.3l9.55-9.55L20.86,1l-9.55,9.55L1.77,1l-.71.71,9.55,9.55L1.06,20.84l.71.71L11.31,12l9.55,9.55.71-.71Z" transform="translate(-1.06 -1.04)" style="fill-rule:evenodd"/></svg>'


    constructor() {
        console.log('new CartItem2024Class')
    }

    cleanTitle(title) {
        title = title.replace("Standard","")
        title = title.replace("Travel","")
        return title
    }
    render() {
        this.item.variant_title = this.cleanTitle(this.item.variant_title)
        let item = this.item

        let itemHtml  = document.createElement( 'div' );
        let cartItemQuantity =
            '<div class="AjaxCart__cart-item-control" >' +
            '<div class="AjaxCart__cart-item-quantity-control AjaxCart__cart-item-quantity-control-down" data-direction="down" >&ndash;</div><div class="AjaxCart__cart-item-quantity"  data-product-product_id="'+item.product_id+'" data-variantId="'+item.id+'" >'+item.quantity+'</div><div class="AjaxCart__cart-item-quantity-control AjaxCart__cart-item-quantity-control-up" data-direction="up" >+</div>' +
            '</div>';

        let priceClass = '';
        if(this.freeGiftVariantId === item.id){
            priceClass = 'text-line-through';
            cartItemQuantity ="";
        }

        let closeInterface= '<div class="AjaxCart__cart-item-remove" data-variantId="'+item.id+'" data-quantity="'+item.quantity+'" >'+this.closeXSvg+'</div>';

        let url = item.url
        // if item is custom candle
        if(item.properties && 'undefined' !== typeof item.properties['_candleName']){
            url = "https://anecdotecandles.com/products/custom-candle?"+item.properties['_pdfLink']
            itemHtml.classList.add('is-candle')
        }

        let cartItemTitle = '<a href="'+url+'" class="d-block color-black" >'+item.product_title+'<br><i class="portrait-regular-italic ">'+item.variant_title+'</i></a>'
        if(true == this.checkIfBundle(item)){
            itemHtml.classList.add('is-bundle')
            cartItemTitle = '<div class="d-block color-black" >'+item.product_title+'<br><i class="portrait-regular-italic ">'+item.variant_title+'</i></div>'
        }
        if(item.properties && 'undefined' !== typeof item.properties['_candleName']){
            cartItemTitle = '<a href="'+url+'" class="d-block color-black" >'+item.product_title+'</a>'
        }

        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        let cartItemRow1 = '<div class="AjaxCart__cart-item-info-row-2024 AjaxCart__cart-item-info-row-2024-1" >' +
            cartItemTitle+
            '<div class="AjaxCart__cart-item-price '+priceClass+'">'+USDollar.format(item.price/100)+'</div>'+
        '</div>';
        let cartItemRow2 = '<div class="AjaxCart__cart-item-info-row AjaxCart__cart-item-info-row-2024-2" >' + cartItemQuantity +closeInterface+ '</div>'

        




        let pImage = "";
        if(item.image){
            pImage = item.image.replace(".jpg", "_medium.jpg").replace(".jpeg", "_medium.jpeg").replace(".png", "_medium.png")
        }
        let cartItemImage = '<a href="'+url+'" ><img alt="" src="'+pImage+'" class="img-fluid" /></a>'
        // bundles don't link
        if(true == this.checkIfBundle(item)){
            cartItemImage = '<div><img alt="" src="'+pImage+'" class="img-fluid" /></div>';
        }
        itemHtml.innerHTML = '<div id="AjaxCart__cart-item-'+item.id+'" class="AjaxCart__cart-item AjaxCart__cart-item-product_id-'+item.product_id+'"><div data-variant-id="'+item.id+'" class="AjaxCart__cart-item-image">'+cartItemImage+'</div><div class="AjaxCart__cart-item-info">'+cartItemRow1+this.getBundleInfo(item)+cartItemRow2+'</div>'+this.renderCustomCandleInfo(item)+'</div>';

        itemHtml.querySelector('.AjaxCart__cart-item-remove').onclick = function(e){
            console.log("remove "+e.currentTarget.getAttribute('data-variantId'),e.currentTarget.getAttribute('data-quantity'));
            let item ={};
            item[e.currentTarget.getAttribute('data-variantId')] = 0;
            AjaxCart.update(item);
            document.querySelector('#AjaxCart__cart-item-'+e.currentTarget.getAttribute('data-variantId'))?.remove()
        };
        let nodelist = itemHtml.querySelectorAll(".AjaxCart__cart-item-quantity-control");
        let quantityControl = itemHtml.querySelector(".AjaxCart__cart-item-quantity");
        for(let i = 0; i  < nodelist.length; i++){
            nodelist[i].onclick = function(e){
                console.log("quantity "+e.currentTarget.getAttribute('data-direction'))
                let quantity = parseInt(quantityControl.innerHTML)
                let variantId = quantityControl.getAttribute('data-variantId')
                let amount = 1

                if("up" === e.currentTarget.getAttribute('data-direction')){
                    quantityControl.innerHTML = quantity+amount;
                }else{
                    if(quantity >= 1){
                        quantityControl.innerHTML = quantity-amount;
                    }
                }
                let item ={};
                item[variantId] = parseInt(quantityControl.innerHTML);
                AjaxCart.update(item)
            }
        }
        this.html = itemHtml
    }


     checkIfBundle(item) {
        let isBundle = false
        if(item.properties && 'undefined' !== typeof item.properties['Candle 1']){
            isBundle = true
        }
        return isBundle;
    }


     renderCustomCandleInfo(item) {
        
        function renderRow(label,value){
            return '<div class="AjaxCart__cart-item-info-custom-candle-row d-flex" ><div class="AjaxCart__cart-item-info-custom-candle-label bolo-grotesk-semi-bold font-xs text-uppercase pt-xs pb-xs" >'+label+'</div><div class="AjaxCart__cart-item-info-custom-candle-value font-sm pt-xs pb-xs" >'+value+'</div></div>'
        }

        let html = ''
        if(item.properties && 'undefined' !== typeof item.properties['_candleName']){
            html = '<div class="AjaxCart__cart-item-info-custom-candle   " >'
            html+= renderRow('Name',item.properties['_candleName'])
            html+= renderRow('Anecdote',item.properties['_candleAnecdote'])
            html+= renderRow('Fragrance',item.properties['_fragranceNote'])
            html+= renderRow('Color',item.properties['_typeColorText'])
            html+= '</div>'
        }
        return html
    }

     getBundleInfo(item) {
        let bundleInfo = ""
        if(item.properties && 'undefined' !== typeof item.properties['Candle 1']){
            bundleInfo = "<div class='font-xs color-anecdote-grey'>"+item.properties['Candle 1']+"</div>"
        }
        if(item.properties && 'undefined' !== typeof item.properties['Candle 2']){
            bundleInfo+= "<div class='font-xs color-anecdote-grey'>"+item.properties['Candle 2']+"</div>"
        }
        if(item.properties && 'undefined' !== typeof item.properties['Candle 3']){
            bundleInfo+= "<div class='font-xs color-anecdote-grey'>"+item.properties['Candle 3']+"</div>"
        }
        if(item.properties && 'undefined' !== typeof item.properties['Candle 4']){
            bundleInfo+= "<div class='font-xs color-anecdote-grey'>"+item.properties['Candle 4']+"</div>"
        }
        if(item.properties && 'undefined' !== typeof item.properties['Candle 5']){
            bundleInfo+= "<div class='font-xs color-anecdote-grey'>"+item.properties['Candle 5']+"</div>"
        }
        if(item.properties && 'undefined' !== typeof item.properties['Candle 6']){
            bundleInfo+= "<div class='font-xs color-anecdote-grey'>"+item.properties['Candle 6']+"</div>"
        }
        return bundleInfo
    }
}


function setCookie(name,value,days) {

    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
    //alert(name+"="+value+expires+"; path=http://batesmasi.com/");

}

function getCookie(c_name)
{
    var i,x,y,ARRcookies=document.cookie.split(";");
    for (i=0;i<ARRcookies.length;i++)
    {
        x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
        y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
        x=x.replace(/^\s+|\s+$/g,"");
        if (x==c_name)
        {
            return  decodeURIComponent(y);
        }
    }
}


class PdP2024Class {

    groups = []
    additionalImagesContainer
    imagesContainer
    layoutInterval
    lastActiveVariant = ""

    constructor() {
        console.log('new PdP2024Class')
        document.addEventListener("DOMContentLoaded", this.initialize.bind(this))
    }

    initialize() {

        this.additionalImagesContainer =  dqs(".main-product-2024__variant-additional-images")
        this.imagesContainer =  dqs(".main-product-2024__images")

        this.buildVariantSlideshows()
    }

    buildVariantSlideshows() {
        let hasSlideshows = false
        dqsa(".pdp-variant-additional-image").forEach((el) => {
            hasSlideshows = true
            if (!this.groups[el.getAttribute('data-variant-handle')]) {
                this.groups[el.getAttribute('data-variant-handle')] = []
            }
            this.groups[el.getAttribute('data-variant-handle')].push(el)
        })

        if(true == hasSlideshows){
            this.buildController()
        }
    }

    buildController() {
        console.log('buildController')
        console.log( this.groups)
        let controller = document.createElement( 'div' )
        controller.innerHTML+= '<div class="pdp-image-controller__inner max-width width-100  padding-lg sm-padding-sm xs-pb-0" ></div>'
        controller.classList.add("pdp-image-controller","position-absolute","width-100","bottom-0","left-0","justify-content-center","d-flex")
        dqs('.main-product-2024__images').append(controller)
        let controllerInner = dqs('.pdp-image-controller__inner')
        for(const key in  this.groups){
           let groupsToggle = document.createElement( 'div' )
           groupsToggle.classList.add('pdp-slideshow-toggle','d-none','mb-lg','sm-mb-sm','xs-pl-sm','pdp-slideshow-toggle-'+key)
           groupsToggle.setAttribute('data-variant-handle',key)
           groupsToggle.innerHTML+= '<span class="pdp-slideshow-toggle-item width-100 d-flex pdp-slideshow-toggle__active" data-index="0" ><span class="sr-only" >Go to slide 0</span><span aria-hidden="true" class="pdp-slideshow-toggle-item__line" ></span></span>'

           for(let i = 1; i  < this.groups[key].length+1; i++){
               groupsToggle.innerHTML+= '<span class="pdp-slideshow-toggle-item  d-flex width-100 " data-index="'+i+'" ><span class="sr-only" >Go to slide '+i+'</span><span aria-hidden="true" class="pdp-slideshow-toggle-item__line" ></span></span>'
           }
           let index = 1
           for(let i = 0; i  < this.groups[key].length; i++){
               this.groups[key][i].setAttribute('data-index',index)
               index++
           }
           controllerInner.append(groupsToggle)
        }

        dqsa(".pdp-slideshow-toggle-item").forEach((el) => {el.addEventListener('click', this.toggleClick.bind(this))})

        this.swipeDetect(this.imagesContainer)

        let context = this
        this.layoutInterval = setInterval(function(){

            let currentVariant = document.body.getAttribute('data-current-variant')

            if(currentVariant != context.lastActiveVariant){
                dqsa(".pdp-slideshow-toggle").forEach((el) => {
                    el.classList.remove('d-flex')
                })

                dqs(".pdp-slideshow-toggle-"+currentVariant)?.classList.add('d-flex')
                context.variantChangeEvent(currentVariant,dqs(".pdp-slideshow-toggle-"+currentVariant+" .pdp-slideshow-toggle__active")?.getAttribute('data-index'))
                context.lastActiveVariant = currentVariant
            }else{

            }

        },500)
    }

    
    

    nextEvent() {
        console.log("next ")
        let targetNode
        dqsa(".pdp-slideshow-toggle__active").forEach((el) => {
            if(el.parentNode.classList.contains('d-flex')){
                let targetIndex = parseInt(el.getAttribute('data-index'))+1
                targetNode = el.parentNode.querySelector(".pdp-slideshow-toggle-item[data-index='"+targetIndex+"']")
                if(targetNode){
                    el.parentNode.querySelectorAll('.pdp-slideshow-toggle__active')?.forEach((tg) => {
                        tg.classList.remove('pdp-slideshow-toggle__active')
                    })
                    this.toggleClickHandler(targetNode)
                }
            }
        })
    }

    prevEvent() {
        console.log("prev ")
        let context = this
        dqsa(".pdp-slideshow-toggle__active").forEach((el) => {
            if(el.parentNode.classList.contains('d-flex')){
                let targetIndex = parseInt(el.getAttribute('data-index'))-1
                let targetNode = el.parentNode.querySelector(".pdp-slideshow-toggle-item[data-index='"+targetIndex+"']")
                if(targetNode){
                    el.parentNode.querySelectorAll('.pdp-slideshow-toggle__active')?.forEach((tg) => {
                        tg.classList.remove('pdp-slideshow-toggle__active')
                    })
                    context.toggleClickHandler(targetNode)
                }
            }
        })
    }

    variantChangeEvent(currentVariantHandle,currentSlideshowIndex) {
        console.log(currentVariantHandle,currentSlideshowIndex)
        if("0" == currentSlideshowIndex){
            this.additionalImagesContainer.classList.remove('opacity-1')
            this.additionalImagesContainer.classList.add('opacity-0')
        }else{

            dqsa(".pdp-variant-additional-image")?.forEach((el) => {
                el.classList.add('opacity-0')
            })

            let query = ".pdp-variant-additional-image-"+currentVariantHandle+"[data-index='"+currentSlideshowIndex+"']"
            this.additionalImagesContainer.querySelector(query)?.classList.remove('opacity-0')
            this.additionalImagesContainer.classList.add('opacity-1')
            if(this.additionalImagesContainer.querySelector(query)?.classList.contains('w_7500xh_3000')){
                this.additionalImagesContainer.classList.add('w_7500xh_3000')
            }else{
                this.additionalImagesContainer.classList.remove('w_7500xh_3000')
            }
        }
    }

    toggleClick(event) {
        this.toggleClickHandler(event.currentTarget)
    }

    toggleClickHandler(currentEl) {
        console.log(currentEl)
        let parentToggle = currentEl.closest('.pdp-slideshow-toggle')
        parentToggle.querySelectorAll('.pdp-slideshow-toggle__active')?.forEach((el) => {
            el.classList.remove('pdp-slideshow-toggle__active')
        })

        currentEl.classList.add('pdp-slideshow-toggle__active')
        this.variantChangeEvent(parentToggle.getAttribute('data-variant-handle'),currentEl.getAttribute('data-index'))
    }



    swipeDetect(el) {

        let context = this

        el.addEventListener('touchstart', handleTouchStart, false);
        el.addEventListener('touchmove', handleTouchMove, false);

        var xDown = null;
        var yDown = null;

        function getTouches(evt) {
            return evt.touches ||             // browser API
                evt.originalEvent.touches; // jQuery
        }

        function handleTouchStart(evt) {
            const firstTouch = getTouches(evt)[0];
            xDown = firstTouch.clientX;
            yDown = firstTouch.clientY;
        }

        function handleTouchMove(evt) {
            if (!xDown || !yDown) {
                return;
            }

            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;

            if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
                if (xDiff > 0) {
                    /* left swipe */
                    context.nextEvent()
                } else {
                    /* right swipe */
                    context.prevEvent()
                }
            } else {
                if (yDiff > 0) {
                    /* up swipe */
                } else {
                    /* down swipe */
                }
            }
            /* reset values */
            xDown = null;
            yDown = null;
        }
    }


}



const PdP2024 = new PdP2024Class()

/*
document.addEventListener("DOMContentLoaded", function() {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
        var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
                if (video.isIntersecting) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazy");
                    lazyVideoObserver.unobserve(video.target)
                }
            });
        });
        lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo)
        });
    }
})

*/


function dqsa(query){
    return document.querySelectorAll(query)
}
function dqs(query){
    return document.querySelector(query)
}






const ApplicationJSClass = function () {


    let headerNavTuggingPoint = 104;
    let lazyLoadInterval;


    document.addEventListener("DOMContentLoaded", function () {
        console.log('main document ready')
        console.log(is2024Preview)
        if(/firefox/i.test(navigator.userAgent)){
            document.body.classList.add('firefox')
        }

        applicationJS.initializePage()

        if (is2024Preview == true) {
            new Anecdote2024Class()
        }

    });





    this.initializePage = function() {
        console.log('initializePage');


        let nodelist = document.querySelectorAll('.SuperSlideshow');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize')
                let superSlideshow = new SuperSlideshow(el);
            }
        }

        nodelist = document.querySelectorAll('.Accordion');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize')
                applicationJS.makeAccordion(el);
            }
        }


        nodelist = document.querySelectorAll('.event-triggers-openQuickAddToCart');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize')
                el.addEventListener('click',(event) => {
                    console.log(el.getAttribute('data-product-id'))
                    applicationJS.openQuickAddToCart(el.getAttribute('data-product-id'))
                })
            }
        }
        nodelist = document.querySelectorAll('.event-click-binds-quickAddToCart');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize')
                el.addEventListener('click',(event) => {
                    applicationJS.quickAddToCart(el.getAttribute('data-product-id'))
                })
            }
        }

        nodelist = document.querySelectorAll('.collabs-page__cta-main');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize')){
                el.classList.add('did-initialize','button','btn-black')
                el.classList.remove('collabs-page__cta-main')

            }
        }

        new VariantSelectorClass()
        
        nodelist = document.querySelectorAll('.product-purchase-flow');
        for (let i=0; i< nodelist.length; i++) {
            let purchaseFlow = new PurchaseFlowClass(nodelist[i]);
        }
        applicationJS.fixPolicyPages()
        applicationJS.addQuickAddInterfaces()

        clearInterval('lazyLoadInterval')
        lazyLoadInterval = setInterval(function(){
            applicationJS.deferredLoading()
            applicationJS.scaleQuickAddInterfaces()
            applicationJS.setHeaderNavTugging()
            applicationJS.cleanStampedStars()
            applicationJS.scaleFilterMenu()
        },400)
        handlePreview()
    }


    this.cleanStampedStars = function(){
        dqsa('.main-product-2024 .stamped-fa')?.forEach((el) => {
            if(!el.classList.contains('did__cleanStampedStars')){
                el.setAttribute('style',"");
                el.classList.add("did__cleanStampedStars","opacity-1")
            }
        })
    }


    this.elementHasScrollbar = function (element) {
        return element.scrollHeight > element.clientHeight;
    }

    this.scaleFilterMenu = function(){
        let filterMenu = dqs('.ProductGrid--controls__container-inner')
        let shifter = dqs('.ProductGrid--controls__container-inner-shifter ')
        let productGridControlsContainer = dqs('.ProductGrid--controls__container')
        if(filterMenu){
            let vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
            let vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
            let mainHeaderHeight = dqs('.main-header')?.clientHeight || 0
            let productGridControlsInterface = dqs('.ProductGrid--controls-interface')?.clientHeight || 0
            let productGridControlsHeadline = dqs('.product-grid-headline')?.clientHeight || 0
            let announcementBar = dqs('#shopify-section-announcement-bar')?.clientHeight || 0
            if(document.body.classList.contains('tugged')){
                announcementBar = 0
            }

            let heightAddOn = 50
            if(vw < 992){
                heightAddOn = 0
            }


            let filterHeight = vh - mainHeaderHeight - productGridControlsInterface -productGridControlsHeadline -announcementBar -heightAddOn
            //console.log(vh,mainHeaderHeight,productGridControlsInterface,productGridControlsHeadline,announcementBar)

            let filterWidth = productGridControlsContainer.clientWidth
            filterMenu.setAttribute('style','width:'+filterWidth+'px')
            shifter.setAttribute('style','height:'+filterHeight+'px;')

            if(this.elementHasScrollbar(shifter)){
                shifter.classList.add('has-scroll-bar')
            }else{
                shifter.classList.remove('has-scroll-bar')
            }


        }

    }

    this.scaleQuickAddInterfaces = function(){

        dqsa('.product-card__mode-plp.quick-add-interface-visible')?.forEach((el) => {
            // check if the mobile quick add is visible
            let check = window.getComputedStyle(el.querySelector('.product-card-2024__price-range-add-to-cart'), null).display
            let height = 'auto'
            if('block' !== check){
                let titleHeight = el.querySelector('.product-card-2024__title-plp')?.clientHeight
                let interfaceHeight = el.querySelector('.product-card-2024__quick-add-interface')?.clientHeight
                height = interfaceHeight-titleHeight+1
                height+= 'px'
            }
            el.querySelector('.quick-add-interface-2024__inner')?.setAttribute('style','height:'+height)
        })

        if(dqsa('.quick-add-interface-visible')?.length > 0 || dqsa('.quick-add-interface-visible__product-recommendations')?.length > 0 ){
            document.body.classList.add('has-visible-quick-add-interface')
        }else{
            document.body.classList.remove('has-visible-quick-add-interface')
        }
    }

    this.hideAllQuickAddInterfaces = function(){
        dqsa('.product-card__mode-plp.quick-add-interface-visible')?.forEach((el) => {
            el.classList.remove('quick-add-interface-visible')
        })
    }

    this.addOrUpdateCart = function(variantId){
        // check if we have the item in cart
        // either update the cart or add the item
        if(dqs(".AjaxCart__cart-item-remove[data-variantid='"+variantId+"']")){
            //console.log("item is in cart")
            let item ={};
            item[variantId] = parseInt(dqs(".AjaxCart__cart-item-quantity[data-variantid='"+variantId+"']").innerHTML)+1;
            AjaxCart.update(item)
        }else{
            //console.log("item is not in cart")
            AjaxCart.quickAddToCart(1,variantId)
        }
    }

    this.addQuickAddInterfaces = function(){
        const context = this

        const clickBackground =  document.createElement( 'div' )
        clickBackground.classList.add("product-card-2024__click-background")
        clickBackground.setAttribute('aria-hidden','true')
        document.getElementById('MainContent').prepend(clickBackground)


        document.querySelector('.product-card-2024__click-background')?.addEventListener('click',(event) => {
            console.log('body click')
            dqsa('.quick-add-interface-visible, .quick-add-interface-visible__product-recommendations')?.forEach((el) => {
                el.classList.remove('quick-add-interface-visible')
                el.classList.remove('quick-add-interface-visible__product-recommendations')
            })
        })

        window.addEventListener("resize", (event) => {context.hideAllQuickAddInterfaces()  })


        let nodelist = document.querySelectorAll('.event-toggles-quick-add-interface');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            if(!el.classList.contains('did-initialize_event-toggles-quick-add-interface')){
                el.classList.add('did-initialize_event-toggles-quick-add-interface')
                let card = el.closest('.product-card-'+el.getAttribute('data-product-id'))
                el.addEventListener('click',(event) => {
                    if(1 != parseInt(card.getAttribute('data-variants-length'))){
                        if(card.classList.contains('quick-add-interface-visible')){
                            context.hideAllQuickAddInterfaces()
                        }else{
                            context.hideAllQuickAddInterfaces()
                            if(el.getAttribute('data-product-id') == "6903480975494") {
                                window.open(card.querySelector('a').getAttribute('href'),'_self')
                            }else {
                                card.classList.add('quick-add-interface-visible')
                            }
                        }
                    }else{
                        this.addOrUpdateCart(card.querySelector('.quick-add-interface-2024__add').getAttribute('data-variant-id'))
                    }
                    applicationJS.scaleQuickAddInterfaces()
                })

                if(el.classList.contains('quick-add-interface-2024__mode-plp') && 1 != parseInt(card.getAttribute('data-variants-length')) ){
                    el.closest('.product-card-2024__quick-add-interface')?.addEventListener('mouseleave',(event) => {
                        //console.log('mouseleave 2')
                        context.hideAllQuickAddInterfaces()
                    })
                }

                if(!el.classList.contains('quick-add-interface-2024__mode-plp') && !el.classList.contains('quick-add-interface-2024__block-hover')  && 1 != parseInt(card.getAttribute('data-variants-length'))){
                    el.addEventListener('mouseenter',(event) => {
                        let interfaces = document.querySelectorAll('.product-card-'+el.getAttribute('data-product-id'))
                        for (let i=0; i< interfaces.length; i++) {
                            //console.log('mouseenter 1'+ interfaces[i].getAttribute('data-product-id'))
                            interfaces[i].classList.add('quick-add-interface-visible')
                            applicationJS.scaleQuickAddInterfaces()
                        }
                    })
                    el.addEventListener('mouseleave',(event) => {
                        let interfaces = document.querySelectorAll('.product-card-'+el.getAttribute('data-product-id'))
                        for (let i=0; i< interfaces.length; i++) {
                            //console.log('mouseleave 1')
                            interfaces[i].classList.remove('quick-add-interface-visible')
                        }
                    })
                }
            }
        }


        dqsa('.event-toggles-quick-add-interface-product-recommendations')?.forEach((el) => {
            if(!el.classList.contains('did-initialize_event-toggles-quick-add-interface-product-recommendations')){
                el.classList.add('did-initialize_event-toggles-quick-add-interface-product-recommendations')
                let card = el.closest('.product-card-'+el.getAttribute('data-product-id'))
                el.addEventListener('click',(event) => {
                    if(1 != parseInt(card.getAttribute('data-variants-length')) && el.getAttribute('data-product-id') != "6903480975494") {
                        event.currentTarget.closest('.product-card-'+el.getAttribute('data-product-id'))?.classList.toggle('quick-add-interface-visible__product-recommendations')
                    }else{

                        if(el.getAttribute('data-product-id') == "6903480975494") {
                            window.open(card.querySelector('a').getAttribute('href'),'_self')
                        }else {
                            this.addOrUpdateCart(card.querySelector('.quick-add-interface-2024__add').getAttribute('data-variant-id'))
                        }
                    }
                })
                if(1 != parseInt(card.getAttribute('data-variants-length')) && el.getAttribute('data-product-id') != "6903480975494") {
                    el.addEventListener('mouseenter', (event) => {
                        let interfaces = document.querySelectorAll('.product-card-' + el.getAttribute('data-product-id'))
                        for (let i = 0; i < interfaces.length; i++) {
                            //console.log('mouseenter 2 product-recommendations '+el.getAttribute('data-product-id'))
                            interfaces[i].classList.add('quick-add-interface-visible__product-recommendations')
                        }
                    })
                }
                el.addEventListener('mouseleave',(event) => {
                    let interfaces = document.querySelectorAll('.quick-add-interface-visible__product-recommendations')
                    for (let i=0; i< interfaces.length; i++) {
                        //console.log('mouseleave 2 product-recommendations')
                        interfaces[i].classList.remove('quick-add-interface-visible__product-recommendations')
                    }
                })
            }
        })

    }

    function handlePreview(){
        console.log('handlePreview');
        let hash = window.location.hash;
        if('#preview' == hash) {
            document.body.classList.add('display-preview');
            document.querySelectorAll('.is-preview').forEach((el) => {
               el.classList.remove("is-preview")
            })
        }

    }

    this.deferredLoading = function(){
        let nodelist = document.querySelectorAll('.appear-event, .lazy-load');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];

            let rect = el.getBoundingClientRect();
            let top_of_object = rect.top;
            let bottom_of_object = rect.bottom;
            let bottom_of_window = window.pageYOffset + window.innerHeight;
            //console.log( bottom_of_window,top_of_object);
            if( bottom_of_window > top_of_object ){
                el.classList.add('appear-event-scrolled-in-view');

                if(el.classList.contains('lazy-load') && !el.classList.contains('initialized-lazy-load')){
                    el.setAttribute('src',el.getAttribute('data-src'));
                    if(el.getAttribute('data-srcset')){
                        el.setAttribute('srcset',el.getAttribute('data-srcset'));
                    }
                    el.classList.add('initialized-lazy-load');
                }

                if(el.getAttribute('data-appear-event') == 'inject-video' && !el.classList.contains('initialized-lazy-load')){
                    el.querySelector('img')?.classList.add('d-none')
                    this.injectVideo(el,el.getAttribute('data-video-url'),el.querySelector('img')?.getAttribute('src'))
                    el.setAttribute('src',el.getAttribute('data-src'))
                    el.classList.add('initialized-lazy-load')
                    el.classList.add('position-relative')
                }
            }
            if( bottom_of_window > bottom_of_object ){

            }
        }
    }

    this.injectVideo = function(el,source,posterUrl){
        el.innerHTML+= '<video class="height-100 width-100 object-fit-cover" width="100%" height="100%" playsinline  autoplay muted loop  poster="'+posterUrl+'">\n' +
            '                <source src="'+source+'" type="video/mp4">\n' +
            '            </video> '
    }

    this.fixPolicyPages = function() {
        let policyBody =   document.querySelector('.shopify-policy__body .rte');
        if(policyBody){
            policyBody.classList.add('texteditor-content');
            policyBody.classList.add('font-md');
        }

        let policyContainer = document.querySelector('.shopify-policy__container');
        if(policyContainer){
            policyContainer.classList.add('pt-xl');
            policyContainer.classList.add('pb-xl');
            policyContainer.parentNode.classList.add('background-floral-white');
            //todo set colors based on url

            let title = document.querySelector('.shopify-policy__title h1');
            document.querySelector('.shopify-policy__title h1').classList.add('d-none');

            let colorClasses = " background-vista-blue  color-shappire-blue ";
            console.log(document.location.href);
            if(document.location.href.indexOf('terms-of-service') > 0){
                colorClasses = " background-tawny-port  color-white ";
            }

            let pageHeader = '<div class="  '+colorClasses+'   pt-xl pb-xl"><div class="page-width">\n' +
                '            <div class="headline-wrapper- headline-1  pageheader__headline   ">\n' +
                '                <div class=" headline-1  pageheader__headline ">\n' +title.innerHTML +
                '                </div>\n' +
                '            </div></div>\n' +
                '        </div>';

            policyContainer.parentNode.innerHTML= pageHeader+policyContainer.parentNode.innerHTML;
        }


    }

    this.setHeaderNavTugging = function() {

        let customCandleProgressBar = document.querySelector('#custom-candle__progress-bar')
        if(customCandleProgressBar){
            let rect = customCandleProgressBar.getBoundingClientRect()
            if(rect.y < 70){
                document.querySelector('body').classList.add('custom-candle__progress-bar-sticky')
            }else{
                document.querySelector('body').classList.remove('custom-candle__progress-bar-sticky')
            }
        }

        if (window.pageYOffset > headerNavTuggingPoint) {
            document.querySelector('body').classList.add('tugged')
        } else {
            document.querySelector('body').classList.remove('tugged')
        }


    }

    this.quickAddToCart = function(id){
        console.log('quickAddToCart form id:'+id)
        let option = document.querySelector('#purchase-form-'+id+' .purchase-form__selector-options-inline .option-selected');
        let quant = document.querySelector('#purchase-form-'+id+' .purchase-form__quantity-select-indicator').innerHTML;

        AjaxCart.quickAddToCart(quant,option.getAttribute('data-variant-id'));
        //e.currentTarget.getAttribute()
    }

    this.openQuickAddToCart = function(id){
        console.log('openQuickAddToCart: '+id)

        if(document.querySelector('#product-card-'+id+'').classList.contains('show-quick-add-to-cart')){
            document.querySelector('#product-card-'+id+'').classList.remove('show-quick-add-to-cart');
            document.body.classList.remove('quick-add-to-cart-active');
        }else{
            document.querySelector('#product-card-'+id+'').classList.add('show-quick-add-to-cart');
            document.body.classList.add('quick-add-to-cart-active');

            document.querySelector('#product-card-'+id+' .purchase-form__close-button').onclick = function(e){
                applicationJS.openQuickAddToCart(id);
            };
        }


    }

    this.initializePurchaseForms = function(){
        let selectors = new VariantSelectorClass()

    }





    this.makeAccordion = function(element) {

        let nodelist = element.querySelectorAll('.AccordionItemTeaserVE');
        for (let i=0; i< nodelist.length; i++) {
            let el = nodelist[i];
            let accordionParent = el;
            el.querySelector(".AccordionItemTeaserVE__title").onclick = function(e){

                if(accordionParent.classList.contains('Accordion-active')){
                    accordionParent.classList.remove('Accordion-active');
                }else{
                    accordionParent.classList.add('Accordion-active');
                }
            }
            el.querySelector(".AccordionItemTeaserVE__title").onkeypress = function(e){

                if(accordionParent.classList.contains('Accordion-active')){
                    accordionParent.classList.remove('Accordion-active');
                }else{
                    accordionParent.classList.add('Accordion-active');
                }
            }
        }
    }



    function getOffset(element) {
        let rect = element.getBoundingClientRect()
        return {
            top: rect.top + window.scrollY,
            left: rect.left + window.scrollX,
        }
    }

    this.scrollToAnchor = function(id,padding) {
        console.log('scrollToAnchor ' + id)
        let element = document.querySelector('#'+id.trim())
        let headerHeight = document.querySelector('header').offsetHeight
        let offset = getOffset(element)
        let offsetTop = offset.top

        window.scrollTo({
            top: offsetTop-headerHeight-padding,
            left: 0,
            behavior: "smooth",
        })

    }


    this.displayInModal = function(html,displayMode) {
        if('above-cart' === displayMode){
            document.body.classList.add('OverlayModal__above-cart');
        }
        document.body.classList.add('in-modal');


        let overlay = document.body.querySelector('#OverlayModal');
        if(overlay){
            overlay.parentNode.removeChild(overlay);
        }

        let modal = document.createElement( 'div' );
        modal.setAttribute('id','OverlayModal');
        modal.innerHTML = '<div class="position-absolute OverlayModal__background-click width-100 cursor-pointer full-height top-0 left-0"></div>';
        modal.innerHTML+= '<div class="OverlayModal__inner-wrapper"><div class="OverlayModal__inner"><div class="OverlayModal__inner-content">'+html+'</div><div class="OverlayModal__inner-close">&times;</></div></div>';
        document.body.appendChild(modal);

        document.body.querySelector('#OverlayModal .OverlayModal__inner-close').onclick = function(e){
            applicationJS.closeOverlayModal()
        }
        document.body.querySelector('#OverlayModal  .OverlayModal__background-click').onclick = function(e){
            applicationJS.closeOverlayModal()
        }
    }
    this.closeOverlayModal = function() {
        let overlay = document.body.querySelector('#OverlayModal')
        document.body.classList.remove('in-modal')
        document.body.classList.remove('OverlayModal__above-cart')
        if(overlay){
            overlay.parentNode.removeChild(overlay);
        }
    }

}

const applicationJS = new ApplicationJSClass();



document.addEventListener('shopify:inspector:activate', () => applicationJS.initializePage())
document.addEventListener('shopify:inspector:deactivate', () => applicationJS.initializePage())
document.addEventListener('shopify:section:load', () => applicationJS.initializePage())
document.addEventListener('shopify:section:unload', () => applicationJS.initializePage())


function swipeDetect(el,eventLeft,eventRight) {

    el.addEventListener('touchstart', handleTouchStart, false);
    el.addEventListener('touchmove', handleTouchMove, false);

    var xDown = null;
    var yDown = null;

    function getTouches(evt) {
        return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
    }

    function handleTouchStart(evt) {
        const firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    }

    function handleTouchMove(evt) {
        if (!xDown || !yDown) {
            return;
        }

        var xUp = evt.touches[0].clientX;
        var yUp = evt.touches[0].clientY;

        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
            if (xDiff > 0) {
                /* left swipe */
                eventLeft()
            } else {
                /* right swipe */
                eventRight()
            }
        } else {
            if (yDiff > 0) {
                /* up swipe */
            } else {
                /* down swipe */
            }
        }
        /* reset values */
        xDown = null;
        yDown = null;
    }
}



